/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useParams,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";
import IntlCurrencyInput from "react-intl-currency-input";
import InputMask from "react-input-mask";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
  Switch,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Stack,
  TextField,
  Chip,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";
import firebase, { storage } from "../../config/firebase";
import { getDownloadURL, ref, uploadString } from "firebase/storage";
import ShipperDialog from "../../components/popup-shipper/insert-shipper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LoopIcon from "@mui/icons-material/Loop";
import TextArea from "antd/es/input/TextArea";
import { Spin } from "antd";
import { Link } from "react-router-dom";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import GalleryDialog from "../frete/components/GalleryDialog";
import AlertDialogFreight from "../frete/components/AlertDialogFreight";
import ModernAlertDialog from "../frete/components/ModernAlertDialog";
import ModernStepper from "./components/ProgressStepsBudget";
import "./budget.css";
import shipperService from "../../service/shipper.service";
import userService from "../../service/user.service";
import Utils from "../../util/utils";
import ProductTable from "../../components/Product-Table-Freight/ProductTable";
import AddIcon from "@mui/icons-material/Add";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InventoryIcon from "@mui/icons-material/Inventory";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import paymentService from "../../service/payment.service";
// CHANGED: util file renamed from pdfOrcamento.js to generateBugetPdf.js
import { gerarPdfOrcamento } from "../../util/generateBugetPdf";
import emailServiceBudget from "../../service/sendEmailWithAttachments.service";
import { fetchBudgetById, createBudget, updateBudget } from "./action/action";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { cardIconSx, newClientThemeVars } from "../../theme/globalStyle/globalStyle";
import './budget.css';
import { Select as AntSelect } from "antd";
import { GlobalSuccessModal, GlobalWarningGlobal, GlobalRequiredFieldsModal } from "../../components/modalGlobal/modalGlobal";
import { validatorCPF, validatorCNPJ } from "../../components/validators/validators";

const STATE_UF = [
  { value: "AC", label: "Acre (AC)" },
  { value: "AL", label: "Alagoas (AL)" },
  { value: "AP", label: "Amapá (AP)" },
  { value: "AM", label: "Amazonas (AM)" },
  { value: "BA", label: "Bahia (BA)" },
  { value: "CE", label: "Ceará (CE)" },
  { value: "DF", label: "Distrito Federal (DF)" },
  { value: "ES", label: "Espírito Santo (ES)" },
  { value: "GO", label: "Goiás (GO)" },
  { value: "MA", label: "Maranhão (MA)" },
  { value: "MT", label: "Mato Grosso (MT)" },
  { value: "MS", label: "Mato Grosso do Sul (MS)" },
  { value: "MG", label: "Minas Gerais (MG)" },
  { value: "PA", label: "Pará (PA)" },
  { value: "PB", label: "Paraíba (PB)" },
  { value: "PR", label: "Paraná (PR)" },
  { value: "PE", label: "Pernambuco (PE)" },
  { value: "PI", label: "Piauí (PI)" },
  { value: "RJ", label: "Rio de Janeiro (RJ)" },
  { value: "RN", label: "Rio Grande do Norte (RN)" },
  { value: "RS", label: "Rio Grande do Sul (RS)" },
  { value: "RO", label: "Rondônia (RO)" },
  { value: "RR", label: "Roraima (RR)" },
  { value: "SC", label: "Santa Catarina (SC)" },
  { value: "SP", label: "São Paulo (SP)" },
  { value: "SE", label: "Sergipe (SE)" },
  { value: "TO", label: "Tocantins (TO)" }
];

require("firebase/auth");

const resolveBudgetIsCopy = (location) => {
  if (location.state?.isCopy === true) {
    return true;
  }

  const params = new URLSearchParams(location.search);
  return params.get("isCopy") === "true";
};

function Budget() {
  let navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const isCopy = resolveBudgetIsCopy(location);
  const shouldCreateBudget = isCopy || !id;
  const user = useSelector((state) => state.user);
  const users = useSelector((state) => state.user);
  const shippers = useSelector((state) => state.shipper);

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("Em Aberto");
  const [code, setCode] = useState("01");
  const [numberSerial, setNumberSerial] = useState(Date.now());

  const [showWarningGlobal, setShowWarningGlobal] = useState(false);
  const [lastWarnedCnpj, setLastWarnedCnpj] = useState("");
  const [warningModalTitle, setWarningModalTitle] = useState("");
  const [showRequiredFieldsModal, setShowRequiredFieldsModal] = useState(false);
  const [requiredFieldsMessages, setRequiredFieldsMessages] = useState([]);
  const [cepNotFoundMap, setCepNotFoundMap] = useState({});

  const getCnpjError = (cnpjValue) => {
    if (!cnpjValue) return "";
    const clean = String(cnpjValue).replace(/\D/g, "");
    if (!clean) return "";
    if (clean.length > 0 && clean.length < 14) {
      return "Esse CNPJ é inválido!";
    }
    if (clean.length === 14 && !validatorCNPJ(clean)) {
      return "Esse CNPJ é inválido!";
    }
    return "";
  };

  const getCepError = (cepValue, index) => {
    if (cepNotFoundMap[index]) return "Esse CEP é inválido!";
    if (!cepValue) return "";
    const clean = String(cepValue).replace(/\D/g, "");
    if (!clean) return "";
    if (clean.length > 0 && clean.length < 8) {
      return "Esse CEP é inválido!";
    }
    return "";
  };

  const handleCnpjStopPointBlur = (valor) => {
    if (!valor || valor.trim() === "") return;
    if (valor === lastWarnedCnpj) return;

    const clean = valor.replace(/\D/g, "");
    if (!validatorCNPJ(clean)) {
      setLastWarnedCnpj(valor);
      setWarningModalTitle("CNPJ do ponto de parada inválido!");
      setShowWarningGlobal(true);
    }
  };

  // Regra de negocio da listagem: se o orcamento ja estiver aprovado, o status fica travado.
  const getLockedApprovedStatus = async (budgetId) => {
    if (!budgetId) return null;

    const budgetDoc = await db.collection("tb_budget").doc(budgetId).get();
    const currentStatus = budgetDoc.data()?.status;

    if (currentStatus?.describe === "Aprovado") {
      return {
        describe: "Aprovado",
        code: currentStatus?.code || "03",
      };
    }

    return null;
  };

  // Pagador
  const [payingCustomer, setPayingCustomer] = useState("");
  const [cnpjPayingCustomer, setCnpjPayingCustomer] = useState("");
  const [uidShipperPayment, setUidShipperPayment] = useState("");
  const [selectedContact, setSelectedContact] = useState("");
  const [shipperContacts, setShipperContacts] = useState([]);

  // Ve?culo
  const [occupation, setOccupation] = useState("");
  const [freeOfCharge, setFreeOfCharge] = useState("");
  const [tipoVeiculo, setTipoVeiculo] = useState({
    dados: [
      { name: "FIORINO", selected: false },
      { name: "3/4", selected: false },
      { name: "TOCO", selected: false },
      { name: "VUC", selected: false },
      { name: "TRUCK", selected: false },
      { name: "BI-TRUCK", selected: false },
      { name: "CARRETA S", selected: false },
      { name: "CARRETA LS", selected: false },
      { name: "RODOTREM", selected: false },
      { name: "VANDERLEIA", selected: false },
    ],
  });
  const [typeBodyworkList, setTypeBodyworkList] = useState({
    dados: [
      { name: "BAÚ", selected: false },
      { name: "BAÚ FRIGORÍFICO", selected: false },
      { name: "BAÚ REFRIGERADO", selected: false },
      { name: "SIDER", selected: false },
      { name: "CAÇAMBA", selected: false },
      { name: "GRADE BAIXA", selected: false },
      { name: "GRANELEIRO", selected: false },
      { name: "PLATAFORMA", selected: false },
      { name: "PRANCHA", selected: false },
      { name: "APENAS CAVALO", selected: false },
      { name: "BUG PORTA CONTÊINER", selected: false },
      { name: "CAVAQUEIRA", selected: false },
      { name: "CEGONHEIRO", selected: false },
      { name: "GAIOLA", selected: false },
      { name: "HOPPER", selected: false },
      { name: "MUNCK", selected: false },
      { name: "SILO", selected: false },
      { name: "TANQUE", selected: false },
    ],
  });

  // Precificacao
  const [product, setProduct] = useState([]);

  // Resumo da Negocia??o
  const [seller, setSeller] = useState(users?.name || "");
  const [sellerId, setSellerId] = useState("");
  const [sellersList, setSellersList] = useState([]);
  const [weightCargo, setWeightCargo] = useState(0);
  const [valueNF, setValueNF] = useState("");
  const [valueFreightage, setValueFreightage] = useState("");
  const [paymentCondition, setPaymentCondition] = useState("");
  // Lista dinamica de condicoes de pagamento vindas do cadastro do embarcador (newEmbarcador).
  const [paymentConditionOptions, setPaymentConditionOptions] = useState([]);
  const [deliveryDeadline, setDeliveryDeadline] = useState("");
  const [observation, setObservation] = useState("");
  const [verifyPayment, setVerifyPayment] = useState(false);

  // Pontos de parada
  const generateNumberCollect = () => {
    const digitosUnicos = new Set();
    while (digitosUnicos.size < 7) {
      const digito = Math.floor(Math.random() * 10);
      digitosUnicos.add(digito);
    }
    return Array.from(digitosUnicos).join("");
  };
  const [formFields, setFormFields] = useState([
    {
      id: "",
      stop_order: 1,
      number_collect: generateNumberCollect(),
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      date_operation: "",
      time_operation: "",
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      observation: "",
    },
  ]);

  const [listShipper, setListShipper] = useState([]);
  const [listECShipper, setListECShipper] = useState("Embarcador");
  const [openShipper, setOpenShipper] = useState(false);
  const [carregando, setCarregando] = useState(0);
  const [msgTipo, setMsgTipo] = useState();
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();
  const [open, setOpen] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalTitle, setSuccessModalTitle] = useState("");
  const [canApprove, setCanApprove] = useState(false);
  const [view, setOnlyView] = useState(location.state?.viewOnly || false);
  const [referenc, setReferenc] = useState("");
  const [origem, setOrigem] = useState("");
  const [openOrigem, setOpenOrigem] = useState(false);
  const [nameButtonImport, setNameButtonImport] = useState("Importar Canhoto");
  const [currentOperationType, setCurrentOperationType] = useState("");

  const db = firebase.firestore();

  // Google Maps API Key (buscar do ambiente ou fallback)
  const key =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    "AIzaSyAds1TwGzvflRvD8KHrbRHrnF3DvATFM1k";

  // Carregar lista de vendedores
  async function loadingSellers() {
    try {
      const list = await userService.usersAssociatedWithFortio();
      setSellersList(list);
    } catch (error) {
      console.error("Erro ao carregar vendedores:", error);
    }
  }

  useEffect(() => {
    loadingSellers();
  }, []);

  useEffect(() => {
    if (sellerId || !seller || !sellersList?.length) return;
    const match = sellersList.find(
      (s) => String(s?.name || "").trim() === String(seller).trim(),
    );
    if (match?.id) {
      setSellerId(match.id);
    }
  }, [seller, sellerId, sellersList]);

  // Extrai e normaliza as condicoes de pagamento salvas no financeiro do embarcador.
  // Suporta tanto o formato novo (array) quanto o legado (campo unico).
  const resolvePaymentConditionsFromShipper = (shipperData) => {
    const financial = shipperData?.financial || {};

    const descriptions = Array.isArray(financial.paymentConditionDescriptions)
      ? financial.paymentConditionDescriptions
      : [];

    const legacyDescription = financial.paymentConditionDescription
      ? [financial.paymentConditionDescription]
      : [];

    const idFallback = Array.isArray(financial.paymentConditionIds)
      ? financial.paymentConditionIds
      : (financial.paymentConditionId ? [financial.paymentConditionId] : []);

    const merged = [...descriptions, ...legacyDescription];

    // Remove vazio/duplicado e, se nao houver descricao, usa ID como fallback visual.
    const normalized = Array.from(
      new Set(
        merged
          .map((item) => String(item || "").trim())
          .filter(Boolean)
      )
    );

    if (normalized.length > 0) return normalized;

    return Array.from(
      new Set(
        idFallback
          .map((item) => String(item || "").trim())
          .filter(Boolean)
      )
    );
  };

  // O pagador do or?amento deve sempre exibir o nome fantasia do embarcador.
  const getShipperDisplayName = (shipperData, fallback = "") =>
    shipperData?.dataPersonal?.nameFantasy || fallback;

  // O autocomplete do pagador usa o nome fantasia como label principal.
  const getShipperOptionLabel = (option) => {
    if (typeof option === "string") return option;
    return (
      option?.dataPersonal?.nameFantasy ||
      option?.dataPersonal?.socialName ||
      ""
    );
  };

  // A busca do pagador filtra pelo nome fantasia digitado.
  const filterShipperByFantasyName = (options, { inputValue }) => {
    const normalizedInput = String(inputValue || "").trim().toLowerCase();
    if (!normalizedInput) return options;

    return options.filter((option) =>
      String(option?.dataPersonal?.nameFantasy || "")
        .toLowerCase()
        .includes(normalizedInput)
    );
  };

  // Busca shipper por nome fantasia ou raz?o social para garantir que o pagador esteja ligado ao embarcador
  async function findShipperByNomeFantasia(nomeFantasia) {
    if (!nomeFantasia) return null;
    const normalized = String(nomeFantasia).trim();
    if (!normalized) return null;

    try {
      // 1) procura exata por nameFantasy
      let query = await db
        .collection("shipper")
        .where("dataPersonal.nameFantasy", "==", normalized)
        .get();

      if (!query.empty) {
        const doc = query.docs[0];
        return { id: doc.id, ...doc.data() };
      }

      // 2) fallback para socialName (raz?o social)
      query = await db
        .collection("shipper")
        .where("dataPersonal.socialName", "==", normalized)
        .get();

      if (!query.empty) {
        const doc = query.docs[0];
        return { id: doc.id, ...doc.data() };
      }

      return null;
    } catch (error) {
      console.error("Erro ao buscar shipper por nome fantasia:", error);
      return null;
    }
  }

  // Carregar shippers
  async function loadingShipper() {
    try {
      if (users?.viewALL) {
        const result = await db.collection("shipper").get();
        const shippers = [];
        result.docs.forEach((doc) => {
          shippers.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setListShipper(shippers);
        setCarregando(0);
      } else {
        if (users?.uidShipperAffiliates && Array.isArray(users.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(users?.uidShipperAffiliates) ? users.uidShipperAffiliates : [];
          const primaryUid = users?.uidShipper ? [users.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          const shippers = [];
          for (const uid of uids) {
            try {
              const docRef = db.collection("shipper").doc(uid);
              const docSnap = await docRef.get();
              if (docSnap.exists) {
                shippers.push({
                  id: docSnap.id,
                  ...docSnap.data(),
                });
              }
            } catch (err) {
              console.error(`Erro ao buscar shipper ${uid}:`, err);
            }
          }
          setListShipper(shippers);
          setCarregando(0);
        } else {
          const result = await db
            .collection("shipper")
            .doc(users.uidShipper)
            .get();
          if (result.exists) {
            setListShipper([
              {
                id: result.id,
                ...result.data(),
              },
            ]);
          }
          setCarregando(0);
        }
      }
    } catch (error) {
      setCarregando(0);
      console.error("Erro ao buscar shippers:", error);
    }
  }

  // Carregar contatos do shipper selecionado diretamente da tabela shipper
  const normalizeTransportOptionName = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();








  const mergeSelectionOptions = (defaultState, incomingState) => {
    const defaultItems = Array.isArray(defaultState?.dados) ? defaultState.dados : [];
    const incomingItems = Array.isArray(incomingState?.dados) ? incomingState.dados : [];

    if (!incomingItems.length) return defaultState;

    const incomingByName = new Map(
      incomingItems.map((item) => [
        normalizeTransportOptionName(item?.name),
        Boolean(item?.selected),
      ])
    );

    return {
      ...defaultState,
      dados: defaultItems.map((item) => {
        const key = normalizeTransportOptionName(item.name);
        return {
          ...item,
          selected: incomingByName.has(key)
            ? incomingByName.get(key)
            : Boolean(item.selected),
        };
      }),
    };
  };
  useEffect(() => {
    const loadContacts = async () => {
      if (uidShipperPayment) {
        try {
          const shipperDoc = await db.collection("shipper").doc(uidShipperPayment).get();
          if (shipperDoc.exists) {
            const shipperData = shipperDoc.data();
            let contacts = [];

            // Normalizar contatos para formato consistente
            if (Array.isArray(shipperData.contact)) {
              // Se for array, normalizar cada contato
              contacts = shipperData.contact.map((contact) => {
                if (typeof contact === "object" && contact !== null) {
                  return {
                    nome: contact.nome || contact.name || "",
                    telefone: contact.telefone || contact.phoneNumberFirst || contact.phone || "",
                    email: contact.email || "",
                  };
                }
                return { nome: "", telefone: String(contact || ""), email: "" };
              });
            } else if (shipperData.contact && typeof shipperData.contact === "object") {
              // Se for objeto unico, converter para array normalizado
              contacts = [{
                nome: shipperData.contact.nome || shipperData.contact.name || "",
                telefone: shipperData.contact.telefone || shipperData.contact.phoneNumberFirst || shipperData.contact.phone || "",
                email: shipperData.contact.email || "",
              }];
            }

            setShipperContacts(contacts);
            // Atualiza as opcoes de pagamento com base no financeiro do embarcador selecionado.
            setPaymentConditionOptions(resolvePaymentConditionsFromShipper(shipperData));
          } else {
            setShipperContacts([]);
            setPaymentConditionOptions([]);
          }
        } catch (error) {
          console.error("Erro ao carregar contatos da tabela shipper:", error);
          setShipperContacts([]);
          setPaymentConditionOptions([]);
        }
      } else {
        setShipperContacts([]);
        setSelectedContact("");
        setPaymentConditionOptions([]);
      }
    };
    loadContacts();
  }, [uidShipperPayment]);

  useEffect(() => {
    loadingShipper();
  }, [users]);

  // Carregar dados do orcamento se estiver editando
  useEffect(() => {
    if (id) {
      loadBudgetData();
    }
  }, [id]);

  async function loadBudgetData() {
    setCarregando(1);
    try {
      const result = await fetchBudgetById(id);
      if (result.success && result.data) {
        const data = result.data;

        // aqui vc pode zera o que vc não quer que apareça na hora do duplicar

        setPayingCustomer(data.clientPayment?.name || "");
        setCnpjPayingCustomer(data.clientPayment?.cnpj || "");
        setUidShipperPayment(data.clientPayment?.uid || "");

        // Carregar o shipper completo para persistir o pagador via uid ou nome fantasia
        let shipperDataFromBudget = null;

        if (data.clientPayment?.uid) {
          try {
            const shipperDoc = await db.collection("shipper").doc(data.clientPayment.uid).get();
            if (shipperDoc.exists) {
              shipperDataFromBudget = {
                id: shipperDoc.id,
                ...shipperDoc.data(),
              };
            }
          } catch (error) {
            console.error("Erro ao carregar shipper por UID:", error);
          }
        }

        if (!shipperDataFromBudget && data.clientPayment?.name) {
          // Busca por nomeFantasia a partir do nome do pagador
          shipperDataFromBudget = await findShipperByNomeFantasia(data.clientPayment.name);
        }

        if (shipperDataFromBudget) {
          // Ao reabrir um or?amento, reidrata o pagador a partir do shipper real.
          setPayingCustomer(getShipperDisplayName(shipperDataFromBudget, data.clientPayment?.name || ""));
          setCnpjPayingCustomer(
            shipperDataFromBudget?.dataPersonal?.documentNumber || data.clientPayment?.cnpj || ""
          );
          setUidShipperPayment(shipperDataFromBudget?.id || data.clientPayment?.uid || "");
          setListECShipper(shipperDataFromBudget);
          setPaymentConditionOptions(resolvePaymentConditionsFromShipper(shipperDataFromBudget));
        }

        // Carregar contato - pode ser objeto ou string
        const contactData = data.contact || "";
        if (contactData && typeof contactData === "object") {
          setSelectedContact(contactData);
        } else {
          setSelectedContact(contactData);
        }
        setOccupation(data.vehicle?.occupation || "");
        setFreeOfCharge(data.vehicle?.freeOfCharge || "");
        setTipoVeiculo((prev) => mergeSelectionOptions(prev, data.vehicle?.typeVehicle));
        setTypeBodyworkList((prev) => mergeSelectionOptions(prev, data.vehicle?.typeBodywork));
        setProduct(data.pricing?.products || []);
        setSeller(data.summary?.seller || "");
        setSellerId(data.summary?.sellerId || "");
        setWeightCargo(data.summary?.weightCargo || 0);
        setValueNF(data.summary?.valueNF || "");
        setValueFreightage(data.summary?.valueFreightage || "");
        setPaymentCondition(data.summary?.paymentCondition || "");
        setDeliveryDeadline(data.summary?.deliveryDeadline || "");
        setObservation(data.summary?.observation || "");
        if (!isCopy) {
          setStatus(data.status?.describe || "Em Aberto");
          setCode(data.status?.code || "01");
          setNumberSerial(data.numberSerial || Date.now());
        }

        // Carregar pontos de parada (ja vem embutido na resposta da API)
        const stops = Array.isArray(data.stopping_points) ? [...data.stopping_points] : [];
        // Ordenar por stop_order para garantir a ordem correta
        stops.sort((a, b) => (a.stop_order || 0) - (b.stop_order || 0));
        const normalizedStops = stops.length > 0
          ? stops.map((stop) => ({
            ...stop,
            id: isCopy ? "" : stop.id,
            number_collect: stop.number_collect || generateNumberCollect(),
          }))
          : formFields;
        setFormFields(normalizedStops);

        if (isCopy) {
          setStatus("Em Aberto");
          setCode("01");
          setNumberSerial(Date.now());
          setCanApprove(true);
        } else if (data.status?.describe !== "Aprovado" && data.status?.describe !== "Cancelado") {
          setCanApprove(true);
        }
      }
      setCarregando(0);
    } catch (error) {
      console.error("Erro ao carregar orçamento:", error);
      setCarregando(0);
    }
  }

  // Handler para mudanca de shipper - garante que todos os dados venham da tabela shipper
  const handleChangeShipper = (shipperData) => {
    if (shipperData) {
      // Garantir que os dados vem diretamente da tabela shipper
      const shipperId = shipperData.id || "";
      const documentNumber = shipperData?.dataPersonal?.documentNumber || "";

      // Atualizar estados com dados da tabela shipper
      setPayingCustomer(getShipperDisplayName(shipperData));
      setCnpjPayingCustomer(documentNumber);
      setUidShipperPayment(shipperId);
      setListECShipper(shipperData);
      // Sincroniza as opcoes de pagamento com o financeiro do embarcador escolhido.
      setPaymentConditionOptions(resolvePaymentConditionsFromShipper(shipperData));

      // Limpar contato selecionado quando mudar o shipper
      setSelectedContact("");
      // Limpa a condicao escolhida para evitar manter opcao invalida do embarcador anterior.
      setPaymentCondition("");
    } else {
      // Se nao houver shipper selecionado, limpar todos os campos
      setPayingCustomer("");
      setCnpjPayingCustomer("");
      setUidShipperPayment("");
      setListECShipper(null);
      setSelectedContact("");
      setShipperContacts([]);
      setPaymentConditionOptions([]);
      setPaymentCondition("");
    }
  };

  // Handler para produtos (precificacao)
  const handleProductsChange = (newProducts) => {
    setProduct(newProducts);
    const total = newProducts?.reduce(
      (sum, prod) => sum + (prod.total || 0),
      0
    ) || 0;
    setValueFreightage(total);
  };

  // Adicionar ponto de parada
  const addFields = () => {
    const object = {
      id: "",
      stop_order: formFields.length + 1,
      number_collect: generateNumberCollect(),
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      date_operation: "",
      time_operation: "",
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      observation: "",
    };
    setFormFields([...formFields, object]);
  };

  // Remover ponto de parada
  const deleteItem = (form, index) => {
    const newFormFields = formFields.filter((_, i) => i !== index);
    // Reordenar
    newFormFields.forEach((field, i) => {
      field.stop_order = i + 1;
    });
    setFormFields(newFormFields);
  };

  // Handler para mudanca nos campos do formulario
  const handleFormChange = (event, index) => {
    const { name, value, type, checked } = event.target;
    const newFormFields = [...formFields];
    if (type === "checkbox") {
      newFormFields[index][name] = checked;
    } else {
      newFormFields[index][name] = value;
    }
    setFormFields(newFormFields);
  };

  // Handler para checkbox de carga/descarga
  const handleCheckBoxChange = (event, index) => {
    const { name, checked } = event.target;
    if (name === "carga" || name === "descarga") {
      setFormFields((prev) => {
        const data = [...prev];
        if (!Array.isArray(data[index].operation)) {
          data[index].operation = [];
        }
        if (checked) {
          data[index].operation = [name];
        } else {
          data[index].operation = [];
        }
        return data;
      });
    }
  };

  //----------------------------- checked box ------------------------------------

  const handleOnChange = (e, type) => {
    const { name, checked } = e.target;
    const newTypeVehicle = [...tipoVeiculo[type]];
    const index = newTypeVehicle.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeVehicle[index] = { name, selected: checked };
    }
    setTipoVeiculo((h) => ({ ...h, [type]: newTypeVehicle }));
  };

  const renderCheckboxList = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChange(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categories = {
    Leve: ["FIORINO", "3/4", "TOCO", "VUC"],
    Medio: ["TRUCK", "BI-TRUCK"],
    Pesado: ["CARRETA S", "CARRETA LS", "RODOTREM", "VANDERLEIA"],
  };

  const renderCategories = () => {
    return Object.keys(categories).map((category) => {
      const filteredOptions = tipoVeiculo.dados.filter((vehicle) =>
        categories[category].includes(vehicle.name)
      );

      return (
        <div key={category}>
          <div className="category-column">
            <h6 className="category-title">{category}</h6>

            {renderCheckboxList(filteredOptions, "dados")}
          </div>
        </div>
      );
    });
  };

  const handleOnChangeBodyWork = (e, type) => {
    const { name, checked } = e.target;
    const newTypeBodyWork = [...typeBodyworkList[type]];
    const index = newTypeBodyWork.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeBodyWork[index] = { name, selected: checked };
    }
    setTypeBodyworkList((h) => ({ ...h, [type]: newTypeBodyWork }));
  };

  const renderCheckboxListBodyWork = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChangeBodyWork(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categoriesBodyWork = {
    Fechada: ["BAÚ", "BAÚ FRIGORÍFICO", "BAÚ REFRIGERADO", "SIDER"],
    Aberta: ["CAÇAMBA", "GRADE BAIXA", "GRANELEIRO", "PLATAFORMA", "PRANCHA"],
    Especial: [
      "BUG PORTA CONTÊINER",
      "CAVAQUEIRA",
      "CEGONHEIRO",
      "GAIOLA",
      "HOPPER",
      "MUNCK",
      "SILO",
      "TANQUE",
    ],
  };

  const renderCategoriesBodyWork = () => {
    return Object.keys(categoriesBodyWork).map((category) => {
      const filteredOptions = typeBodyworkList.dados.filter((vehicle) =>
        categoriesBodyWork[category].includes(vehicle.name)
      );
      return (
        <div key={category}>
          <div className="category-column">
            <h6 style={{ fontWeight: "bold", fontSize: "14px" }}>{category}</h6>
            {renderCheckboxListBodyWork(filteredOptions, "dados")}
          </div>
        </div>
      );
    });
  };

  // Funcoes auxiliares
  function handleNameButtonImport(index) {
    if (index === "carga") {
      setNameButtonImport("Importar Canhoto");
      return;
    } else {
      setNameButtonImport("Importar imagens");
    }
  }

  const duplicateForm = (index) => {
    setFormFields((prev) => {
      const formToDuplicate = prev[index];
      if (!formToDuplicate) {
        console.error("Formulário não encontrado no índice:", index);
        return prev;
      }
      let newForm = JSON.parse(JSON.stringify(formToDuplicate));
      newForm.stop_order = formToDuplicate.stop_order + 1;
      newForm.date_operation = "";
      newForm.time_operation = "";
      newForm.observation = "";
      newForm.number_collect = Date.now();
      return [...prev, newForm];
    });
  };

  const geocodeStopPoint = (index, logradouro, number, city, uf) => {
    if (!logradouro || !city || !uf) return;

    const enderecoCompleto = number
      ? `${logradouro} ${number} ${city} ${uf}`
      : `${logradouro} ${city} ${uf}`;

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(enderecoCompleto)}&key=${key}`
    )
      .then((res) => res.json())
      .then((data2) => {
        if (data2.status === "OK") {
          const coords = data2.results[0].geometry.location;
          setFormFields((prev) => {
            const next = [...prev];
            next[index] = {
              ...next[index],
              latitude: coords.lat,
              longitude: coords.lng,
              checkItemLocation: true,
            };
            return next;
          });
        }
      })
      .catch((err) => console.error("Erro ao buscar coordenadas:", err));
  };

  function buscarCNPJBancoClient(input, index) {
    if (input.length < 14) {
      return;
    } else if (input.length === 14 || input.length === 18) {
      const inputLimpo = input.replace(/[^\d]/g, "");

      // Primeiro verificar se o CNPJ corresponde ao CNPJ do pagador
      const cnpjPayingCustomerLimpo = cnpjPayingCustomer?.replace(/[^\d]/g, "") || "";

      if (inputLimpo === cnpjPayingCustomerLimpo && uidShipperPayment) {
        // Se corresponder ao pagador, buscar dados do shipper
        db.collection("shipper")
          .doc(uidShipperPayment)
          .get()
          .then((shipperDoc) => {
            if (shipperDoc.exists) {
              const shipperData = shipperDoc.data();
              const address = shipperData.address || {};
              const logradouro = `${address.street || ""}${address.neighborhood ? " - " + address.neighborhood : ""}`.trim();
              const number = address.numeroEndereco || address.number || "";
              const city = address.city || "";
              const uf = address.state || "";

              // Preencher campos com dados do shipper
              setFormFields((prev) => {
                const newForm = [...prev];
                newForm[index] = {
                  ...newForm[index],
                  name: getShipperDisplayName(shipperData, payingCustomer || ""),
                  cpf_cnpj: shipperData.dataPersonal?.documentNumber || cnpjPayingCustomer || "",
                  cep: address.cep || "",
                  number: number,
                  logradouro: logradouro,
                  city: city,
                  uf: uf,
                  // Preencher responsavel se houver contato
                  responsible_name: shipperData.contact && typeof shipperData.contact === "object" && !Array.isArray(shipperData.contact)
                    ? (shipperData.contact.name || shipperData.contact.nome || "")
                    : (Array.isArray(shipperData.contact) && shipperData.contact.length > 0
                      ? (shipperData.contact[0].name || shipperData.contact[0].nome || "")
                      : ""),
                  responsible_phone: shipperData.contact && typeof shipperData.contact === "object" && !Array.isArray(shipperData.contact)
                    ? (shipperData.contact.phoneNumberFirst || shipperData.contact.telefone || "")
                    : (Array.isArray(shipperData.contact) && shipperData.contact.length > 0
                      ? (shipperData.contact[0].phoneNumberFirst || shipperData.contact[0].telefone || "")
                      : ""),
                };
                return newForm;
              });

              geocodeStopPoint(index, logradouro, number, city, uf);
            }
          })
          .catch((err) => {
            console.error("Erro ao buscar dados do shipper:", err);
            // Se der erro, continuar com busca normal na tabela client
            buscarNaTabelaClient(inputLimpo, index);
          });
      } else {
        // Se nao corresponder ao pagador, buscar na tabela client normalmente
        buscarNaTabelaClient(inputLimpo, index);
      }
    }
  }

  // Funcao auxiliar para buscar na tabela client
  function buscarNaTabelaClient(inputLimpo, index) {
    db.collection("client")
      .where("cnpj", "==", inputLimpo)
      .get()
      .then((result) => {
        if (!result.empty) {
          const data = result.docs[0].data();
          const logradouro = `${data.address?.street || ""} - ${data.address?.neighborhood || ""}`;
          const number = data.address?.number || "";
          const city = data.address?.city || "";
          const uf = data.address?.state || "";
          setFormFields((prev) => {
            const newForm = [...prev];
            newForm[index] = {
              ...newForm[index],
              name: data.name,
              cpf_cnpj: data.cnpj,
              cep: data.address?.cep || "",
              number: number,
              logradouro: logradouro,
              city: city,
              uf: uf,
              latitude: data.coordinates?.latitude || "",
              longitude: data.coordinates?.longitude || "",
            };
            return newForm;
          });

          if (!data.coordinates?.latitude || !data.coordinates?.longitude) {
            geocodeStopPoint(index, logradouro, number, city, uf);
          }
        }
      })
      .catch((err) => console.error(err));
  }

  function buscarCepPaying(input, index) {
    if (input.length < 8) return;
    const inputLimpo = input.replace(/[^\d]/g, "");

    fetch("https://brasilapi.com.br/api/cep/v1/" + inputLimpo)
      .then((res) => res.json())
      .then((data) => {
        if (data.hasOwnProperty("erro") || data.name === "CepPromiseError") {
          setCepNotFoundMap((prev) => ({ ...prev, [index]: true }));
        } else {
          setCepNotFoundMap((prev) => ({ ...prev, [index]: false }));
          const logradouroCompleto = (data.street || "") + " - " + (data.neighborhood || "");

          setFormFields((prev) => {
            const aux = [...prev];
            aux[index] = {
              ...aux[index],
              logradouro: logradouroCompleto,
              city: data.city || "",
              uf: data.state || "",
            };
            return aux;
          });

          const numeroAtual = String(formFields?.[index]?.number || "").trim();
          geocodeStopPoint(
            index,
            logradouroCompleto,
            numeroAtual,
            data.city || "",
            data.state || ""
          );
        }
      })
      .catch((err) => console.error("Erro ao buscar CEP:", err));
  }

  const handleStopPointAddressBlur = (index, fieldName, fieldValue) => {
    const nextValue = String(fieldValue || "").trim();

    if (fieldName === "cep") {
      const cepLimpo = nextValue.replace(/\D/g, "");
      if (cepLimpo.length === 8) {
        buscarCepPaying(cepLimpo, index);
        return;
      }
    }

    consultStreetByStreet(index, {
      [fieldName]: nextValue,
    });
  };

  function consultStreetByStreet(index, overrides = {}) {
    const item = {
      ...(formFields?.[index] || {}),
      ...(overrides || {}),
    };
    if (!item.logradouro || !item.city || !item.uf) {
      // Se nao tiver endereco completo, nao busca coordenadas
      return;
    }

    // Monta o endereco completo, incluindo numero se disponivel
    const enderecoCompleto = item.number
      ? `${item.logradouro} ${item.number} ${item.city} ${item.uf}`
      : `${item.logradouro} ${item.city} ${item.uf}`;

    fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(enderecoCompleto)}&key=${key}`)
      .then((res) => res.json())
      .then((data2) => {
        if (data2.status === "OK") {
          const coords = data2.results[0].geometry.location;
          setFormFields((prev) => {
            const newForm = [...prev];
            newForm[index] = {
              ...newForm[index],
              latitude: coords.lat,
              longitude: coords.lng,
              checkItemLocation: true,
            };
            return newForm;
          });
        }
      })
      .catch((err) => console.error("Erro ao buscar coordenadas:", err));
  }

  const handleClickOpen = (id, operationType) => {
    setOpenOrigem(true);
    setReferenc(id);
    setCurrentOperationType(operationType || "");
  };

  const handleCloseModal = () => {
    setOpenOrigem(false);
  };

  const handleUpload = (file) => {
    if (!file) return;
    // Implementar logica de upload se necessario
    console.log("Upload file:", file);
  };

  const handleShipperCloseModal = () => {
    setOpenShipper(false);
  };

  const getDadaClient = (cnpj, razaosocial) => {
    setPayingCustomer(razaosocial);
    setCnpjPayingCustomer(cnpj);
  };

  const collectMissingFields = () => {
    const missing = [];

    if (!cnpjPayingCustomer) missing.push("CNPJ do Pagador");
    if (!payingCustomer) missing.push("Pagador");
    if (!selectedContact || selectedContact === "") missing.push("Contato");
    if (!occupation) missing.push("Ocupacao");
    if (!freeOfCharge) missing.push("Livre de Carga e Descarga");
    if (!seller) missing.push("Vendedor");
    if (!valueNF) missing.push("Valor NF");
    if (!weightCargo) missing.push("Peso Transportado");
    if (!valueFreightage) missing.push("Valor do Frete");
    if (!paymentCondition) missing.push("Condições de Pagamento");
    if (!deliveryDeadline && deliveryDeadline !== 0) missing.push("Prazo de Entrega");

    if (!formFields || formFields.length === 0) {
      missing.push("Pelo menos um ponto de parada");
      return missing;
    }

    formFields.forEach((stop, idx) => {
      const order = stop.stop_order || idx + 1;
      const prefix = `Ponto ${order}:`;

      if (!stop.name) missing.push(`${prefix} Nome/Razão Social`);
      if (!stop.cpf_cnpj) missing.push(`${prefix} CNPJ/CPF`);
      if (!stop.cep) missing.push(`${prefix} CEP`);
      if (!stop.logradouro) missing.push(`${prefix} Endereço`);
      if (!stop.number) missing.push(`${prefix} Numero`);
      if (!stop.city) missing.push(`${prefix} Cidade`);
      if (!stop.uf) missing.push(`${prefix} UF`);
      if (!stop.operation || stop.operation.length === 0) {
        missing.push(`${prefix} Selecione Carga ou Descarga`);
      }

      if (stop.operation?.includes("carga")) {
        if (!stop.type) missing.push(`${prefix} Tipo da Carga`);
        if (!stop.descricao) missing.push(`${prefix} Descrição da Carga`);
      }
    });

    for (const prod of getFilledProducts(product)) {
      if (!prod.hasName || !prod.hasAmount || !prod.hasPriceList) {
        missing.push("Precificacao: preencha nome, quantidade e valor unitario para cada item informado");
        break;
      }
    }

    return missing;
  };

  // Validacao
  function validInput() {
    const missing = collectMissingFields();
    if (missing.length > 0) {
      setRequiredFieldsMessages(missing);
      setShowRequiredFieldsModal(true);
      setCarregando(0);
      return false;
    }
    return true;
  }

  function showMessage(msg) {
    setMsgTipo("erro");
    setCarregando(0);
    setTitle("Atenção!");
    setMsg(msg);
    setOpen(true);
    return;
  }

  // Monta os pontos de parada no formato exigido pelo StoppingPointSchema do back
  // (latitude/longitude precisam ser number; o form guarda como string).
  function buildStoppingPointsPayload(fields) {
    return fields.map((field, index) => ({
      stop_order: field.stop_order || index + 1,
      name: field.name || "",
      cpf_cnpj: field.cpf_cnpj || "",
      cep: field.cep || "",
      logradouro: field.logradouro || "",
      number: field.number || "",
      city: field.city || "",
      uf: field.uf || "",
      latitude: parseFloat(field.latitude) || 0,
      longitude: parseFloat(field.longitude) || 0,
      date_operation: field.date_operation || "",
      time_operation: field.time_operation || "",
      operation: Array.isArray(field.operation) ? field.operation : [],
      type: field.type || "",
      descricao: field.descricao || "",
      canhoto: field.canhoto || "",
      checkItemLocation: !!field.checkItemLocation,
      concluded: !!field.concluded,
      id: field.id || "",
      manualCoordinatesEnabled: !!field.manualCoordinatesEnabled,
      number_collect: String(field.number_collect || ""),
      observation: field.observation || "",
      responsible_name: field.responsible_name || "",
      responsible_phone: field.responsible_phone || "",
      typeCarga: !!field.typeCarga,
      typeDescarga: !!field.typeDescarga,
      verify: !!field.verify,
    }));
  }

  // Salvar orcamento / approve budget
  async function save(options = {}) {
    if (view) return null;

    const { redirect = true } = options;
    setMsgTipo("erro");
    setCarregando(1);

    //campo obg
    if (!validInput()) return null;

    // Ao editar um orcamento aprovado, preserva o status original na listagem.
    const lockedApprovedStatus = isCopy
      ? null
      : await getLockedApprovedStatus(id);
    const chosenStatus = lockedApprovedStatus || {
      describe: status,
      code: code,
    };

    //declara campos do orcamento p/ update e create
    // Persiste o pagador com o nome fantasia exibido em tela.
    let customerPayment = {
      name: getShipperDisplayName(listECShipper, payingCustomer),
      cnpj: cnpjPayingCustomer,
      uid: uidShipperPayment,
    };

    let vehicle = {
      typeVehicle: tipoVeiculo,
      typeBodywork: typeBodyworkList,
      occupation: occupation,
      freeOfCharge: freeOfCharge,
    };

    let pricing = {
      products: toPersistedProducts(product),
    };

    let summary = {
      seller: seller,
      sellerId: sellerId || "",
      weightCargo: weightCargo,
      valueNF: valueNF,
      valueFreightage: valueFreightage,
      paymentCondition: paymentCondition,
      deliveryDeadline: deliveryDeadline,
      observation: observation,
      // Persistimos a quantidade de paradas extras para manter o mesmo valor ao reemitir PDF.
      additionalStops: Math.max((formFields?.length || 0) - 2, 0),
    };

    // Primeira e ultima rota
    var primeiraRota = formFields
      .filter((item) => item.stop_order)
      .slice(0, 1)[0];

    var ultimaRota = formFields.filter((item) => item.stop_order).slice(-1)[0];

    var firstDelivery = {
      name: primeiraRota.name,
      cep: primeiraRota.cep,
      address: primeiraRota.logradouro,
      city: primeiraRota.city,
      uf: primeiraRota.uf.length > 2
        ? Utils.searchingState(primeiraRota.uf)
        : primeiraRota.uf,
      dateColeta: primeiraRota.date_operation,
      coordinates: {
        latitude: primeiraRota.latitude,
        longitude: primeiraRota.longitude,
      },
    };

    var lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf: ultimaRota?.uf.length > 2
        ? Utils.searchingState(ultimaRota.uf)
        : ultimaRota.uf,
      dateColeta: ultimaRota.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    let shipper = {
      uid: users.uidShipper,
      name: shippers?.dataPersonal?.nameFantasy || shippers?.dataPersonal?.socialName || "",
    };

    let userData = {
      uid: users.uid,
      name: users.name,
    };

    var data = {  //dados do orcamento 
      clientPayment: customerPayment,
      contact: selectedContact,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      status: chosenStatus,
      numberSerial: numberSerial,
      vehicle: vehicle,
      pricing: pricing,
      summary: summary,
      user: userData,
      shipper: shipper,
      createUser: users.email || "",
      createData: new Date(),
    };


    try {
      if (!shouldCreateBudget) {



        //update
        const stopping_points = buildStoppingPointsPayload(formFields);
        const result = await updateBudget(id, { ...data, stopping_points });

        if (!result.success) {
          throw new Error(result.error || "Erro ao atualizar orçamento");
        }

        setCarregando(0);
        setMsgTipo("sucesso");
        setCanApprove(true);
        if (redirect) {
          setSuccessModalTitle("Orçamento atualizado com sucesso!");
          setShowSuccessModal(true);
        }
        return result.data?.id || id;
      } else {


        // Create
        const stopping_points = buildStoppingPointsPayload(formFields);
        const result = await createBudget({ ...data, stopping_points });

        if (!result.success) {
          throw new Error(result.error || "Erro ao criar orçamento");
        }


        setCarregando(0);
        setMsgTipo("sucesso");
        setCanApprove(true);
        if (redirect) {
          setSuccessModalTitle("Orçamento cadastrado com sucesso!");
          setShowSuccessModal(true);
        }
        return result.data?.id;
      }
    } catch (error) {
      console.error("Erro ao salvar orçamento:", error);
      setMsgTipo("erro");
      setCarregando(0);
      showMessage("Erro ao salvar orçamento");
    }
  }

  // Aprovar orcamento
  async function approveBudget() {
    if (view) return false;

    if (isCopy) {
      showMessage("Salve o orçamento duplicado antes de aprovar");
      return false;
    }

    if (!id) {
      showMessage("Orçamento não encontrado");
      return false;
    }

    try {
      setCarregando(1);

      // Salva o estado atual da tela antes de transferir para o frete copy.
      const savedBudgetId = await save({ redirect: false });
      if (!savedBudgetId) {
        setCarregando(0);
        return false;
      }



      //BUSCA NO BACK ORCAMENTO CRIADO p/ levar ao frete
      const budgetLookup = await fetchBudgetById(savedBudgetId);
      if (!budgetLookup.success || !budgetLookup.data) {
        showMessage("Orçamento não encontrado");
        setCarregando(0);
        return false;
      }

      const budgetData = budgetLookup.data;
      const stops = budgetData.stopping_points || [];

      // Preparar dados para transferir para o frete
      const freightData = {
        fromBudget: true,
        budgetId: savedBudgetId,
        budgetData: budgetData,
        stops: stops,
        // Dados do pagador
        clientPayment: budgetData.clientPayment,
        // Dados do veiculo
        vehicle: budgetData.vehicle,
        // Dados da precificacao
        pricing: budgetData.pricing,
        // Dados do resumo
        summary: budgetData.summary,
        // Numero serial
        numberSerial: budgetData.numberSerial,
      };

      // Navegar para a tela de frete com os dados do orcamento
      navigate("/freightCopy", {
        state: freightData,
      });

      setCarregando(0);
      return true;
    } catch (error) {
      console.error("Erro ao aprovar orçamento:", error);
      setCarregando(0);
      showMessage("Erro ao aprovar orçamento");
      return false;
    }
  }

  async function cancelBudget() {
    if (isCopy) {
      showMessage("Salve o orçamento duplicado antes de cancelar");
      return false;
    }

    if (!id) {
      showMessage("Orçamento não encontrado");
      return false;
    }

    try {
      setCarregando(1);


      //busca o orcamento antes de cancelar
      const budgetLookup = await fetchBudgetById(id);
      if (!budgetLookup.success || !budgetLookup.data) {
        showMessage("Orçamento não encontrado");
        setCarregando(0);
        return false;
      }

      const result = await updateBudget(id, {
        ...budgetLookup.data,
        status: {
          describe: "Cancelado",
          code: "04",
        },
      });

      if (!result.success) {
        throw new Error(result.error || "Erro ao cancelar orçamento");
      }

      setStatus("Cancelado");
      setCode("04");
      setCanApprove(false);
      setCarregando(0);
      return true;
    } catch (error) {
      console.error("Erro ao cancelar orçamento:", error);
      setCarregando(0);
      showMessage("Erro ao cancelar orçamento");
      return false;
    }
  }

  //Aplicar mudança de status
  const handleStatusStepperConfirm = async (nextStatus) => {
    if (view) return false;

    if (isCopy) {
      showMessage("Salve o orçamento duplicado antes de alterar o status");
      return false;
    }

    if (nextStatus === "Aprovado") {
      return await approveBudget();
    }
    if (nextStatus === "Cancelado") {
      return await cancelBudget();
    }
    return false;
  };

  const formatCurrencyBRL = (value) => {
    // Formata valores numericos no padrao monetario brasileiro para uso no PDF.
    const numericValue = Number(value || 0);
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const getSelectedNames = (list) =>
    // Retorna apenas os nomes dos itens marcados nas listas de veiculo/carroceria.
    (list?.dados || [])
      .filter((item) => item.selected)
      .map((item) => item.name);

  const extractContactData = (contactValue) => {
    // Normaliza o contato selecionado para um objeto unico com nome, telefone e email.
    if (!contactValue) return { nome: "-", telefone: "-", email: "-" };

    if (typeof contactValue === "object") {
      return {
        nome: contactValue.nome || contactValue.name || "-",
        telefone: contactValue.telefone || contactValue.phoneNumberFirst || contactValue.phone || "-",
        email: contactValue.email || "-",
      };
    }

    if (typeof contactValue === "string") {
      try {
        const parsed = JSON.parse(contactValue);
        return {
          nome: parsed.nome || parsed.name || "-",
          telefone: parsed.telefone || parsed.phoneNumberFirst || parsed.phone || "-",
          email: parsed.email || "-",
        };
      } catch {
        const parts = contactValue.split(" - ").map((part) => part.trim());
        return {
          nome: parts[0] || "-",
          telefone: parts[1] || "-",
          email: parts[2] || "-",
        };
      }
    }

    return { nome: "-", telefone: "-", email: "-" };
  };

  const normalizeContactObject = (contactValue) => {
    // Normaliza contato em formato estavel para evitar divergencia no value do Select.
    if (!contactValue || typeof contactValue !== "object") {
      return { nome: "", telefone: "", email: "" };
    }
    return {
      nome: contactValue.nome || contactValue.name || "",
      telefone:
        contactValue.telefone ||
        contactValue.phoneNumberFirst ||
        contactValue.phone ||
        "",
      email: contactValue.email || "",
    };
  };

  const contactToSelectValue = (contactValue) => {
    // Converte contato para string JSON com ordem fixa de chaves (nome, telefone, email).
    if (!contactValue || contactValue === "") return "";
    if (typeof contactValue === "string") {
      try {
        const parsed = JSON.parse(contactValue);
        return JSON.stringify(normalizeContactObject(parsed));
      } catch {
        return contactValue;
      }
    }
    return JSON.stringify(normalizeContactObject(contactValue));
  };

  const normalizeText = (value) => {
    // Normaliza strings para comparacoes sem diferenca de acento/caixa.
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  };

  const canShareBudgetPdf = (statusValue) => {
    // Mantemos os envios disponiveis tambem para orcamento aprovado,
    // pois o usuario ainda pode precisar reenviar o PDF por e-mail ou WhatsApp.
    const normalizedStatus = normalizeText(statusValue);
    return ["em aberto", "enviado", "aprovado"].includes(normalizedStatus);
  };

  const isValidEmail = (emailValue) => {
    // Valida o formato basico de e-mail antes de tentar enviar.
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(emailValue || "").trim());
  };

  const toPdfFileToken = (value, fallback) => {
    // Sanitiza cada trecho do nome do PDF para manter padrao seguro no Storage/SO.
    const token = normalizeText(value)
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    return token || fallback;
  };

  const buildBudgetPdfFileName = (dadosPdf) => {

    // Orcamento_NOMEDOPAGADOR_ORIGEM_UF_DESTINO_UF_1770410579030.pdf
    const pagadorToken = toPdfFileToken(dadosPdf?.pagador, "SEM_PAGADOR");
    const origemUfToken = toPdfFileToken(dadosPdf?.origemUF, "SEM_ORIGEM");
    const destinoUfToken = toPdfFileToken(dadosPdf?.destinoUF, "SEM_DESTINO");
    return `Orcamento_${pagadorToken}_${origemUfToken}_${destinoUfToken}_${Date.now()}.pdf`;
  };

  const resolveSelectedContactEmail = (contactValue, contactsList = []) => {
    // Resolve o e-mail do contato selecionado com fallback para a lista completa de contatos do pagador.
    const directContact = extractContactData(contactValue);
    const directEmail = String(directContact?.email || "").trim();
    if (isValidEmail(directEmail)) return directEmail;

    if (typeof contactValue === "string") {
      const emailFromString = contactValue.match(/[^\s@]+@[^\s@]+\.[^\s@]+/);
      if (emailFromString?.[0] && isValidEmail(emailFromString[0])) {
        return emailFromString[0].trim();
      }
    }

    const normalizedName = normalizeText(directContact?.nome);
    const normalizedPhone = String(directContact?.telefone || "").replace(/\D/g, "");

    const matchedContact = (contactsList || []).find((contact) => {
      const normalizedContactName = normalizeText(contact?.nome || contact?.name);
      const normalizedContactPhone = String(
        contact?.telefone || contact?.phoneNumberFirst || contact?.phone || ""
      ).replace(/\D/g, "");

      const nameMatches =
        normalizedName &&
        normalizedContactName &&
        normalizedName === normalizedContactName;

      const phoneMatches =
        normalizedPhone &&
        normalizedContactPhone &&
        normalizedPhone === normalizedContactPhone;

      return nameMatches || phoneMatches;
    });

    const matchedEmail = String(matchedContact?.email || "").trim();
    return isValidEmail(matchedEmail) ? matchedEmail : "";
  };

  const getSellerContactData = () => {
    // Busca o vendedor selecionado dentro da lista vinda do cadastro de usuarios.
    // O PDF deve refletir os dados do vendedor escolhido no Orcamento, nao apenas do usuario logado.
    const normalizedSellerName = normalizeText(seller);
    const sellerRecord = (sellersList || []).find((item) => {
      const normalizedRecordName = normalizeText(item?.name);
      const normalizedRecordEmail = normalizeText(item?.email);

      return (
        (normalizedSellerName && normalizedRecordName === normalizedSellerName) ||
        (normalizedSellerName && normalizedRecordEmail === normalizedSellerName)
      );
    });

    const fallbackUserMatchesSelectedSeller =
      normalizeText(users?.name) === normalizedSellerName ||
      normalizeText(users?.email) === normalizedSellerName;

    return {
      nome: sellerRecord?.name || seller || users?.name || "-",
      telefone:
        sellerRecord?.phoneNumber ||
        sellerRecord?.phoneNumberFirst ||
        sellerRecord?.phone ||
        sellerRecord?.telefone ||
        (fallbackUserMatchesSelectedSeller
          ? users?.phoneNumber ||
          users?.phoneNumberFirst ||
          users?.phone ||
          users?.telefone
          : "") ||
        "-",
      email:
        sellerRecord?.email ||
        (fallbackUserMatchesSelectedSeller ? users?.email || "" : ""),
    };
  };

  const resolveBudgetContactData = () => {
    const selected = extractContactData(selectedContact);
    const hasSelectedData = [selected?.nome, selected?.telefone, selected?.email].some(
      (value) => String(value || "").trim() && value !== "-"
    );

    if (hasSelectedData) return selected;

    return extractContactData(shipperContacts?.[0] || "");
  };

  const STOP_TYPE_LABELS = {
    "01": " Granel Solido",
    "02": " Granel Liquido",
    "03": " Frigorificada",
    "04": " Containerizada",
    "05": " Carga Geral",
    "06": " Neogranel",
    "07": " Perigosa (granel solido)",
    "08": " Perigosa (granel liquido)",
    "09": " Perigosa (carga frigorificada)",
    "10": " Perigosa (containerizada)",
    "11": " Perigosa (carga geral)",
  };

  const getStopTypeLabel = (typeValue) => {
    const normalizedType = String(typeValue || "").trim();
    if (!normalizedType) return "";

    return STOP_TYPE_LABELS[normalizedType] || normalizedType;
  };

  const buildStopsDescriptionForPdf = (stops = []) => {
    const descriptions = (stops || [])
      .filter((stop) => Array.isArray(stop?.operation) && stop.operation.includes("carga"))
      .map((stop) =>
        // Mantem somente a descricao digitada no ponto de parada para PDF e WhatsApp.
        String(stop?.descricao || stop?.description || stop?.Descricao || "").trim()
      )
      .filter(Boolean);

    return descriptions.length > 0
      ? descriptions.join(", ").toUpperCase()
      : "FRETE DEDICADO";
  };

  const hasProductValue = (value) =>
    value !== null &&
    value !== undefined &&
    !(typeof value === "string" && value.trim() === "");

  const normalizeBudgetProduct = (item) => {
    const descricao = String(
      item?.nameProducts ||
      item?.description ||
      item?.descricao ||
      item?.name ||
      item?.nameProduct ||
      item?.typeService ||
      ""
    ).trim();

    const amountRaw =
      item?.amount ??
      item?.quantity ??
      item?.qtd ??
      null;

    const priceRaw =
      item?.priceList ??
      item?.price ??
      item?.value ??
      item?.valor ??
      null;

    const hasName = hasProductValue(descricao);
    const hasAmount = hasProductValue(amountRaw);
    const hasPriceList = hasProductValue(priceRaw);

    const amount = hasAmount ? Number(amountRaw) : null;
    const priceList = hasPriceList ? Number(priceRaw) : null;
    const total = Number(item?.total || 0) || ((amount || 0) * (priceList || 0));

    return {
      descricao,
      amount,
      priceList,
      total,
      hasName,
      hasAmount,
      hasPriceList,
      isEmpty: !hasName && !hasAmount && !hasPriceList,
      isComplete: hasName && hasAmount && hasPriceList,
    };
  };

  const getBudgetProductRows = (products = []) =>
    (products || []).map(normalizeBudgetProduct);

  const getFilledProducts = (products = []) =>
    getBudgetProductRows(products).filter((prod) => !prod.isEmpty);

  const getCompleteProducts = (products = []) =>
    getBudgetProductRows(products).filter((prod) => prod.isComplete);

  const toPersistedProducts = (products = []) =>
    getCompleteProducts(products).map((prod) => ({
      nameProducts: prod.descricao,
      amount: prod.amount,
      priceList: prod.priceList,
      total: prod.total,
      netPrice: prod.total,
    }));

  const toPdfItems = (products = []) =>
    getCompleteProducts(products).map((item, index) => ({
      item: index + 1,
      descricao: item.descricao,
      qtd: item.amount,
      valor: item.priceList,
      total: item.total,
    }));

  const formatDeliveryDeadlineLabel = (value) => {
    const normalizedValue = String(value ?? "").trim();
    if (!normalizedValue) return "-";

    if (/^\d+$/.test(normalizedValue)) {
      const days = Number(normalizedValue);
      return `${days} dia${days === 1 ? "" : "s"}`;
    }

    return normalizedValue;
  };

  const buildBudgetPdfData = () => {
    // Monta os dados padrao do orcamento usados no PDF e no e-mail.
    const firstStop = formFields?.[0] || {};
    const lastStop = formFields?.[formFields.length - 1] || {};
    const pontosAdicionais = Math.max((formFields?.length || 0) - 2, 0);
    const vehicles = getSelectedNames(tipoVeiculo);
    const bodyworks = getSelectedNames(typeBodyworkList);
    const itensPdf = toPdfItems(product);
    const materiaisPdf = buildStopsDescriptionForPdf(formFields);
    const contato = resolveBudgetContactData();
    const vendedorContato = getSellerContactData();

    return {
      firstStop,
      lastStop,
      contato,
      vendedorContato,
      dadosPdf: {
        numero: numberSerial || "-",
        dataOrcamento: Utils.formatDateBR(new Date()),
        pagador: payingCustomer || "-",
        vendedor: vendedorContato.nome,
        contatoNome: contato.nome !== "-" ? contato.nome : "-",
        contatoTelefone: contato.telefone,
        contatoEmail: contato.email,
        vendedorTelefone: vendedorContato.telefone,
        vendedorEmail: vendedorContato.email,
        origemCidade: firstStop.city || "-",
        origemUF: firstStop.uf || "-",
        destinoCidade: lastStop.city || "-",
        destinoUF: lastStop.uf || "-",
        pontosAdicionais,
        previsao: formatDeliveryDeadlineLabel(deliveryDeadline),
        modal: occupation || "-",
        veiculo: vehicles.length ? vehicles.join(", ") : "-",
        carroceria: bodyworks.length ? bodyworks.join(", ") : "-",
        peso: weightCargo ? `${weightCargo} kg` : "-",
        valorTransportado: valueNF ? formatCurrencyBRL(valueNF) : "-",
        materiais: materiaisPdf,
        valorFrete: formatCurrencyBRL(valueFreightage),
        total: formatCurrencyBRL(valueFreightage),
        prazoPagamento: paymentCondition || "-",
        observacoes: observation || "-",
        itens: itensPdf,
      },
    };
  };

  const buildBudgetEmailTemplate = ({ pagadorNome, origem, destino, clienteNome, vendedor }) => {
    // Monta assunto e corpo de e-mail conforme o modelo de apresentacao do orcamento.
    const subject = `Orcamento - ${pagadorNome} - Frete ${origem} para ${destino}`;

    const html = `
      <div style="font-family: Arial, sans-serif; color: #111; line-height: 1.5;">
        <p>Prezado(a) ${clienteNome},</p>
        <p>Conforme solicitado, segue em anexo o or&ccedil;amento referente ao servi&ccedil;o de transporte.</p>
        <p>Ficamos &agrave; disposi&ccedil;&atilde;o para esclarecer qualquer d&uacute;vida ou realizar eventuais ajustes que sejam necess&aacute;rios. Assim que aprovado, poderemos dar andamento &agrave; programa&ccedil;&atilde;o do servi&ccedil;o.</p>
        <p>Agradecemos pela oportunidade.</p>
        <br />
        <p>Atenciosamente,</p>
        <p>${vendedor.nome}<br />Fortio Transportes<br />${vendedor.telefone}<br />${vendedor.email || "-"}</p>
      </div>
    `;

    return { subject, html };
  };

  const normalizePhoneToWhatsapp = (phoneValue) => {
    // Normaliza telefone para formato aceito pelo wa.me (somente digitos com DDI 55).
    const digits = String(phoneValue || "").replace(/\D/g, "");
    if (!digits) return "";
    return digits.startsWith("55") ? digits : `55${digits}`;
  };

  const normalizeWhatsappText = (value) => {
    // Mantem o texto do WhatsApp estavel e tenta reparar mojibake comum antes do encode.
    const text = String(value ?? "")
      .replace(/\r\n/g, "\n")
      .replace(/\uFFFD/g, "");

    if (!/[??]/.test(text)) {
      return text;
    }

    try {
      return decodeURIComponent(escape(text));
    } catch {
      return text;
    }
  };

  const buildBudgetWhatsAppMessage = ({ dadosPdf }) => {
    // Monta mensagem padrao de cotacao para WhatsApp.
    const origem = normalizeWhatsappText(`${dadosPdf.origemCidade || "-"} - ${dadosPdf.origemUF || "-"}`);
    const destino = normalizeWhatsappText(`${dadosPdf.destinoCidade || "-"} - ${dadosPdf.destinoUF || "-"}`);
    const mercadoriaTransportada = String(dadosPdf.materiais || "").trim() && dadosPdf.materiais !== "-"
      ? dadosPdf.materiais
      : Array.isArray(dadosPdf.itens) && dadosPdf.itens.length
        ? dadosPdf.itens
          .map((item) => String(item?.descricao || "").trim())
          .filter(Boolean)
          .join(", ")
        : (dadosPdf.materiais || "-");
    const veiculoCarroceria = [dadosPdf.veiculo, dadosPdf.carroceria]
      .filter((value) => String(value || "").trim() && value !== "-")
      .join(" / ") || "-";

    return [
      `Prezado(a), ${normalizeWhatsappText(dadosPdf.contatoNome || "-")}`,
      "",
      `Conforme nossa conversa e conforme solicitado, estou encaminhando o orçamento referente ao serviço de transporte no trecho ${origem} para ${destino}.`,
      "",
      "Cotação de Frete",
      `Origem: ${origem}`,
      `Destino: ${destino}`,
      `Modalidade: ${normalizeWhatsappText(dadosPdf.modal || "-")}`,
      `Veículo/Carroceria: ${normalizeWhatsappText(veiculoCarroceria)}`,
      `Prazo de Entrega: ${normalizeWhatsappText(dadosPdf.previsao || "-")}`,
      `Mercadoria Transportada: ${normalizeWhatsappText(mercadoriaTransportada || "-")}`,
      `Valor da Mercadoria: ${normalizeWhatsappText(dadosPdf.valorTransportado || "-")}`,
      `Peso Transportado: ${normalizeWhatsappText(dadosPdf.peso || "-")}`,
      `Valor Total: ${normalizeWhatsappText(dadosPdf.total || "-")}`,
      `Condição de Pagamento: ${normalizeWhatsappText(dadosPdf.prazoPagamento || "-")}`,
      `Pagador: ${normalizeWhatsappText(dadosPdf.pagador || "-")}`,
      `Observações: ${normalizeWhatsappText(dadosPdf.observacoes || "-")}`,
      "",
      "Fico à disposição para esclarecer qualquer dúvida ou ajustar o que for necessário para atendê-lo da melhor forma possível.",
      "",
      "Atenciosamente,",
      `${normalizeWhatsappText(dadosPdf.vendedor || "-")}`,
      "Fortio Transportes",
    ]
      .map(normalizeWhatsappText)
      .join("\n");
  };

  const uploadBudgetPdfAndGetPublicUrl = async ({ budgetId, fileName, pdfBase64 }) => {
    // Publica o PDF no Firebase Storage e retorna URL + path para referencia no e-mail.
    const storagePath = `budget/${budgetId}/attachments/${fileName}`;
    const storageRef = ref(storage, storagePath);
    await uploadString(storageRef, pdfBase64, "base64", {
      contentType: "application/pdf",
    });
    const pdfUrl = await getDownloadURL(storageRef);
    return { pdfUrl, storagePath };
  };

  async function sendBudgetPdfByWhatsApp() {
    // Salva or?amento, gera PDF, cria URL p?blica e abre mensagem autom?tica no WhatsApp.
    try {
      setCarregando(1);
      const savedBudgetId = await save({ redirect: false });
      if (!savedBudgetId) return;

      const { contato, dadosPdf } = buildBudgetPdfData();
      const whatsappPhone = normalizePhoneToWhatsapp(contato?.telefone);
      const fileName = buildBudgetPdfFileName(dadosPdf);

      if (!whatsappPhone) {
        setTitle("Telefone não cadastrado");
        setMsg("Envio via WhatsApp indisponível. O embarcador não possui telefone cadastrado. Cadastre um número para continuar.");
        setOpen(true);
        setCarregando(0);
        return;
      }

      const pdfBase64 = await gerarPdfOrcamento(dadosPdf, { output: "base64" });
      const sanitizedPdfBase64 = String(pdfBase64 || "")
        .replace(/^data:application\/pdf;base64,/, "")
        .trim();

      if (!sanitizedPdfBase64 || sanitizedPdfBase64.length < 100) {
        throw new Error("Falha ao gerar PDF em base64 para WhatsApp.");
      }

      await uploadBudgetPdfAndGetPublicUrl({
        budgetId: savedBudgetId,
        fileName,
        pdfBase64: sanitizedPdfBase64,
      });

      // Tambem faz o download local do PDF ao enviar pelo WhatsApp.
      await gerarPdfOrcamento(dadosPdf, { fileName });

      const message = buildBudgetWhatsAppMessage({ dadosPdf });
      let copiedToClipboard = false;
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(message);
          copiedToClipboard = true;
        }
      } catch (clipboardError) {
        console.warn("[BudgetWhatsApp] Falha ao copiar mensagem para area de transferencia.", clipboardError);
      }
      const whatsappUrl = `https://wa.me/${whatsappPhone}?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, "_blank", "noopener,noreferrer");

      const lockedApprovedStatus = await getLockedApprovedStatus(savedBudgetId);
      if (!lockedApprovedStatus) {
        await db.collection("tb_budget").doc(savedBudgetId).update({
          status: {
            describe: "Enviado",
            code: "02",
          },
        });

        setStatus("Enviado");
        setCode("02");
      } else {
        setStatus(lockedApprovedStatus.describe);
        setCode(lockedApprovedStatus.code);
      }
      setCanApprove(true);
      setTitle("Sucesso");
      setMsg(
        copiedToClipboard
          ? "Mensagem formatada copiada para a area de transferencia e WhatsApp aberto."
          : "WhatsApp aberto com a mensagem formatada da cotacao."
      );
      setOpen(true);
      setCarregando(0);
    } catch (error) {
      console.error("Erro ao enviar orçamento por WhatsApp:", error);
      setCarregando(0);
      showMessage("Erro ao preparar envio do orçamento por WhatsApp.");
    }
  }

  async function sendBudgetPdfByEmail() {
    // Salva o or?amento, envia e-mail com refer?ncia do PDF e altera automaticamente o status para "Enviado".

    try {
      setCarregando(1);
      const savedBudgetId = await save({ redirect: false });
      if (!savedBudgetId) return;

      const { firstStop, lastStop, contato, vendedorContato, dadosPdf } = buildBudgetPdfData();
      const emailContato = resolveSelectedContactEmail(selectedContact, shipperContacts);
      const fileName = buildBudgetPdfFileName(dadosPdf);

      if (!isValidEmail(emailContato)) {
        setTitle("E-mail não cadastrado");
        setMsg("O embarcador não tem e-mail cadastrado para envio do PDF. Corrija o cadastro do contato e tente novamente.");
        setOpen(true);
        setCarregando(0);
        return;
      }

      const origemFrete = `${firstStop?.city || "-"} - ${firstStop?.uf || "-"}`;
      const destinoFrete = `${lastStop?.city || "-"} - ${lastStop?.uf || "-"}`;
      const emailTemplate = buildBudgetEmailTemplate({
        pagadorNome: payingCustomer || "-",
        origem: origemFrete,
        destino: destinoFrete,
        clienteNome: contato?.nome && contato.nome !== "-" ? contato.nome : "Cliente",
        vendedor: vendedorContato,
      });

      // Gera o PDF e publica no Storage para enviar apenas referencia ao backend.
      const pdfBase64 = await gerarPdfOrcamento(dadosPdf, { output: "base64" });
      const sanitizedPdfBase64 = String(pdfBase64 || "")
        .replace(/^data:application\/pdf;base64,/, "")
        .trim();

      if (!sanitizedPdfBase64 || sanitizedPdfBase64.length < 100) {
        throw new Error("Falha ao gerar PDF para envio por e-mail.");
      }

      const { pdfUrl, storagePath } = await uploadBudgetPdfAndGetPublicUrl({
        budgetId: savedBudgetId,
        fileName,
        pdfBase64: sanitizedPdfBase64,
      });

      const htmlWithPublicUrl = `
        ${emailTemplate.html}
        <p>Acesse o or&ccedil;amento pelo link:</p>
        <p>
          <a
            href="${pdfUrl}"
            target="_blank"
            rel="noreferrer noopener"
            style="display:inline-block;padding:10px 16px;background:#012443;color:#ffffff;text-decoration:none;border-radius:6px;font-weight:600;"
          >
            Abrir or&ccedil;amento
          </a>
        </p>
      `;

      console.log("[BudgetEmail] PDF publicado no Storage com sucesso", {
        budgetId: savedBudgetId,
        storagePath,
      });

      let responseEmail = null;
      try {
        responseEmail = await emailServiceBudget.sendEmailBudget({
          to: emailContato,
          subject: emailTemplate.subject,
          html: htmlWithPublicUrl,
          replyTo: isValidEmail(vendedorContato.email) ? vendedorContato.email : undefined,
          attachmentRefs: [
            {
              filename: fileName,
              url: pdfUrl,
              storagePath,
              contentType: "application/pdf",
            },
          ],
          attachments: [],
        });

        if (!responseEmail?.success) {
          throw new Error(responseEmail?.message || "Falha no envio do e-mail com anexo server-side.");
        }
      } catch (attachmentError) {
        console.warn("[BudgetEmail] Falha no envio com attachmentRefs. Enviando somente com link publico.", attachmentError);

        responseEmail = await emailServiceBudget.sendEmailBudget({
          to: emailContato,
          subject: emailTemplate.subject,
          html: htmlWithPublicUrl,
          replyTo: isValidEmail(vendedorContato.email) ? vendedorContato.email : undefined,
          attachments: [],
          attachmentRefs: [],
        });

        if (!responseEmail?.success) {
          throw new Error(responseEmail?.message || "Falha no envio do e-mail com URL publica.");
        }
      }

      const lockedApprovedStatus = await getLockedApprovedStatus(savedBudgetId);
      if (!lockedApprovedStatus) {
        await db.collection("tb_budget").doc(savedBudgetId).update({
          status: {
            describe: "Enviado",
            code: "02",
          },
        });

        setStatus("Enviado");
        setCode("02");
      } else {
        setStatus(lockedApprovedStatus.describe);
        setCode(lockedApprovedStatus.code);
      }
      setCanApprove(true);
      setTitle("Sucesso");
      setMsg("Orçamento enviado por e-mail com sucesso.");
      setOpen(true);
      setCarregando(0);
    } catch (error) {
      console.error("Erro ao enviar e-mail do orçamento:", error);
      setCarregando(0);
      setTitle("Erro no envio");
      setMsg(error?.message || "Não foi possível enviar o orçamento por e-mail.");
      setOpen(true);
    }
  }
  async function saveAndEmitPdfV2() {
    if (view) return;

    // Salva o orçamento, gera o PDF de apresentação e atualiza o status para "Enviado".
    try {
      const savedBudgetId = await save({ redirect: false });
      if (!savedBudgetId) return;

      const firstStop = formFields?.[0] || {};
      const lastStop = formFields?.[formFields.length - 1] || {};
      const pontosAdicionais = Math.max((formFields?.length || 0) - 2, 0);
      const vehicles = getSelectedNames(tipoVeiculo);
      const bodyworks = getSelectedNames(typeBodyworkList);
      const itensPdf = toPdfItems(product);
      const materiaisPdf = buildStopsDescriptionForPdf(formFields);
      const contato = resolveBudgetContactData();
      const vendedorContato = getSellerContactData();

      const dadosPdf = {
        numero: numberSerial || "-",
        dataOrcamento: Utils.formatDateBR(new Date()),
        pagador: payingCustomer || "-",
        vendedor: vendedorContato.nome,
        contatoNome: contato.nome !== "-" ? contato.nome : "-",
        contatoTelefone: contato.telefone,
        contatoEmail: contato.email,
        vendedorTelefone: vendedorContato.telefone,
        vendedorEmail: vendedorContato.email,
        origemCidade: firstStop.city || "-",
        origemUF: firstStop.uf || "-",
        destinoCidade: lastStop.city || "-",
        destinoUF: lastStop.uf || "-",
        pontosAdicionais,
        previsao: formatDeliveryDeadlineLabel(deliveryDeadline),
        modal: occupation || "-",
        veiculo: vehicles.length ? vehicles.join(", ") : "-",
        carroceria: bodyworks.length ? bodyworks.join(", ") : "-",
        peso: weightCargo ? `${weightCargo} kg` : "-",
        valorTransportado: valueNF ? formatCurrencyBRL(valueNF) : "-",
        materiais: materiaisPdf,
        valorFrete: formatCurrencyBRL(valueFreightage),
        total: formatCurrencyBRL(valueFreightage),
        prazoPagamento: paymentCondition || "-",
        observacoes: observation || "-",
        itens: itensPdf,
      };

      // Aplica o mesmo padrao de nome tambem no download direto do PDF.
      const fileName = buildBudgetPdfFileName(dadosPdf);
      await gerarPdfOrcamento(dadosPdf, { fileName });

      const lockedApprovedStatus = await getLockedApprovedStatus(savedBudgetId);
      if (!lockedApprovedStatus) {
        await db.collection("tb_budget").doc(savedBudgetId).update({
          status: {
            describe: "Enviado",
            code: "02",
          },
        });

        setStatus("Enviado");
        setCode("02");
      } else {
        setStatus(lockedApprovedStatus.describe);
        setCode(lockedApprovedStatus.code);
      }
      setCanApprove(true);
      setCarregando(0);
      navigate("/budget/list");
    } catch (error) {
      console.error("Erro ao emitir PDF do orçamento:", error);
      setCarregando(0);
      showMessage("Erro ao emitir PDF do orçamento");
    }
  }

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const weightConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const handleChangeWeightCargo = (event, value, maskedValue) => {
    setWeightCargo(value);
  };

  const handleChangeValueNF = (event, value, maskedValue) => {
    setValueNF(value);
  };

  const handleChangeValueFreightage = (event, value, maskedValue) => {
    setValueFreightage(value);
  };

  const handleChangePaymentCondition = (event) => {
    setPaymentCondition(event.target.value);
  };


  const pageTitle = view ? "Visualizar orçamento" : shouldCreateBudget ? "Novo orçamento" : "Editar orçamento";
  const pageSubtitle = view
    ? "Consulte os dados do orçamento."
    : "Preencha os dados do orçamento e os pontos de parada.";



  return (
    <>
      {useSelector((state) => state.usuarioLogado) > 0 ? (
        <NewMiniDrawer
          divOpen={
            <Box className="budget-form-page" sx={pageWrapperSx} style={newClientThemeVars}>

              {/* Dialogs */}
              <AlertDialogFreight
                handleClose={handleCloseModal}
                open={openOrigem}
                origem={origem}
                handleUpload={handleUpload}
                operationType={currentOperationType}
              />

              <ShipperDialog
                handleClose={handleShipperCloseModal}
                open={openShipper}
                dadosClient={getDadaClient}
              />

              {/* Cabecalho */}
              <Card sx={heroCardSx}>
                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                  <Box className="budget-form-hero">
                    <Stack spacing={1}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={cardIconSx}>
                          <Inventory2OutlinedIcon sx={{ color: "#ffffff" }} />
                        </Box>
                        <Typography sx={heroTitleSx}>{pageTitle}</Typography>
                      </Box>
                      <Typography sx={heroSubtitleSx}>{pageSubtitle}</Typography>
                    </Stack>

                    <Box sx={statusPillSx}>
                      {view ? "Somente leitura" : shouldCreateBudget ? "Novo registro" : "Atualização"}
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              <Card sx={heroCardSx}>
                <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                  <Stack direction="column" spacing={2}>
                    <Typography sx={heroSubtitleSx}>
                      {"Número do orçamento: "}<strong>{numberSerial}</strong>
                    </Typography>

                    <Box role="group" aria-label={"Status do orçamento"} sx={{ width: "100%" }}>
                      <ModernStepper
                        propsStatus={code}
                        onStatusConfirm={handleStatusStepperConfirm}
                      />
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
              <div className="container-fluid px-0">
                {/* Pagador */}
                <SectionCard
                  icon={<PersonIcon sx={{ color: "#ffffff" }} />}
                  title="Pagador"
                  subtitle="Dados do pagador, CNPJ e contato usados neste orcamento."
                >
                  <Box className="budget-form-grid">
                    <Field label="Pagador *" span={4}>
                      <Autocomplete
                        id="payingCustomer"
                        size="small"
                        disabled={view}
                        value={listECShipper && listECShipper}
                        options={listShipper}
                        getOptionLabel={getShipperOptionLabel}
                        filterOptions={filterShipperByFantasyName}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onChange={(event, value) => {
                          handleChangeShipper(value);
                          setPayingCustomer(getShipperDisplayName(value));
                        }}
                        noOptionsText="Nenhum Embarcador com esse nome foi encontrado"
                        renderInput={(params) => <TextField {...params} label="" />}
                      />
                    </Field>

                    <Field label="CNPJ *" span={3}>
                      <InputMask
                        mask="99.999.999/9999-99"
                        maskChar=""
                        className="form-control"
                        value={cnpjPayingCustomer || ""}
                        disabled
                        readOnly
                      >
                        {(inputProps) => (
                          <input {...inputProps} id="cnpjPayingCustomer" type="text" disabled readOnly />
                        )}
                      </InputMask>
                    </Field>

                    <Field label="Contato *" span={5}>
                      <Select
                        disabled={view}
                        value={contactToSelectValue(selectedContact)}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "") {
                            setSelectedContact("");
                          } else {
                            try {
                              const parsed = JSON.parse(value);
                              setSelectedContact(normalizeContactObject(parsed));
                            } catch {
                              setSelectedContact(value);
                            }
                          }
                        }}
                        fullWidth
                        size="small"
                        displayEmpty
                        renderValue={(value) => {
                          if (!value || value === "") return "Selecione um contato";
                          if (typeof value === "string") {
                            try {
                              const parsed = JSON.parse(value);
                              const parts = [];
                              if (parsed.nome) parts.push(parsed.nome);
                              if (parsed.telefone) parts.push(parsed.telefone);
                              if (parsed.email) parts.push(parsed.email);
                              return parts.length > 0 ? parts.join(" - ") : value;
                            } catch {
                              return value;
                            }
                          }
                          const contact = value;
                          const parts = [];
                          if (contact.nome) parts.push(contact.nome);
                          if (contact.telefone) parts.push(contact.telefone);
                          if (contact.email) parts.push(contact.email);
                          return parts.length > 0 ? parts.join(" - ") : "Contato";
                        }}
                      >
                        <MenuItem value="">Selecione um contato</MenuItem>
                        {shipperContacts.map((contact, index) => {
                          const normalizedContact =
                            typeof contact === "object" && contact !== null
                              ? normalizeContactObject(contact)
                              : { nome: "", telefone: String(contact || ""), email: "" };
                          const contactValue = JSON.stringify(normalizedContact);

                          return (
                            <MenuItem key={index} value={contactValue}>
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {normalizedContact.nome && (
                                  <strong style={{ fontSize: "0.95em" }}>{normalizedContact.nome}</strong>
                                )}
                                <div style={{ fontSize: "0.85em", color: "#666" }}>
                                  {normalizedContact.telefone && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                      <PhoneIcon fontSize="small" /> {normalizedContact.telefone}
                                    </div>
                                  )}
                                  {normalizedContact.email && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                      <EmailIcon fontSize="small" /> {normalizedContact.email}
                                    </div>
                                  )}
                                  {!normalizedContact.telefone && !normalizedContact.email && !normalizedContact.nome && "Contato"}
                                </div>
                              </div>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Field>
                  </Box>
                </SectionCard>


                {/* Pontos de Parada */}
                <SectionCard
                  icon={<LocationOnIcon sx={{ color: "#ffffff" }} />}
                  title="Pontos de Parada"
                  subtitle="Cadastre as paradas de carga e descarga deste orcamento."
                >

                  {formFields.map((form, index) => {
                    const indiceReal = index;

                    return (
                      <Card
                        key={index}
                        sx={{ mb: 2, ...sectionCardSx, background: form.canhoto ? "#f2f8fb" : sectionCardSx.background }}
                      >
                        <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                          <Spin spinning={loading} size="Large">
                            {/* LINHA 1 */}
                            <Box className="budget-form-grid">
                              <Field label="Ordenação" span={1}>
                                <input
                                  disabled={view}
                                  type="number"
                                  name="stop_order"
                                  min={1}
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  value={form.stop_order && form.stop_order}
                                  className="form-control"
                                  id="ordenacao"
                                  placeholder=""
                                />
                              </Field>

                              <div className="budget-form-field budget-form-span-3">
                                <FormControl component="fieldset">
                                  <FormLabel id="demo-row-radio-buttons-group-label">
                                    <label className="font-test">
                                      Tipo de Parada <span style={{ color: "red" }}>*</span>
                                    </label>
                                  </FormLabel>

                                  <Stack direction="row" spacing={2}>
                                    <FormControlLabel
                                      disabled={view}
                                      value="carga"
                                      name="carga"
                                      onChange={(event) => {
                                        handleFormChange(event, indiceReal, "carga");
                                        handleNameButtonImport("carga");
                                        handleCheckBoxChange(event, indiceReal);
                                      }}
                                      control={
                                        <Checkbox
                                          value={form.operation[0] && form.operation[0]}
                                          checked={form.operation.includes("carga")}
                                          disabled={form.operation.includes("descarga")}
                                        />
                                      }
                                      label="Carga"
                                    />


                                    <FormControlLabel
                                      disabled={view}
                                      value="descarga"
                                      name="descarga"
                                      onChange={(event) => {
                                        handleFormChange(event, indiceReal, "descarga");
                                        handleNameButtonImport("descarga");
                                        handleCheckBoxChange(event, indiceReal);
                                      }}
                                      control={
                                        <Checkbox
                                          value={form.operation[1] && form.operation[1]}
                                          checked={form.operation.includes("descarga")}
                                          disabled={form.operation.includes("carga")}
                                        />
                                      }
                                      label="Descarga"
                                    />
                                  </Stack>
                                </FormControl>
                              </div>
                              <div className="budget-form-field budget-form-span-2" style={{ alignSelf: "flex-end" }}>
                                <Stack direction="row" spacing={1}>
                                  <IconButton
                                    disabled={view}
                                    size="large"
                                    onClick={() => duplicateForm(indiceReal)}
                                    color="primary"
                                    aria-label="duplicate"
                                  >
                                    <ContentCopyIcon />
                                  </IconButton>

                                  <IconButton
                                    disabled={view}
                                    size="large"
                                    onClick={(e) => deleteItem(form, indiceReal)}
                                    color="error"
                                    aria-label="delete"
                                  >
                                    <DeleteForeverIcon />
                                  </IconButton>
                                </Stack>
                              </div>
                              {/* LINHA 2 */}
                              <Field label="CNPJ *" span={4} style={{ gridColumn: "1 / span 4" }}>
                                <InputMask
                                  disabled={view}
                                  mask="99.999.999/9999-99"
                                  maskChar=""
                                  className="form-control"
                                  name="cpf_cnpj"
                                  value={form.cpf_cnpj || ""}
                                  onChange={(event) => {
                                    buscarCNPJBancoClient(event.target.value, indiceReal);
                                    handleFormChange(event, indiceReal);
                                  }}
                                >
                                  {(inputProps) => <input {...inputProps} id="cnpj" placeholder="00.000.000/0000-00" />}
                                </InputMask>
                                {form.cpf_cnpj && getCnpjError(form.cpf_cnpj) ? (
                                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                    {getCnpjError(form.cpf_cnpj)}
                                  </span>
                                ) : null}
                              </Field>

                              <Field label="Razão Social *" span={8} style={{ gridColumn: "5 / span 8" }}>
                                <input
                                  disabled={view}
                                  type="text"
                                  name="name"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  value={form.name || ""}
                                  className="form-control"
                                  id="name"
                                  placeholder="Nome ou razão social"
                                />
                              </Field>

                              {/* LINHA 3 */}
                              <Field label="CEP *" span={2} style={{ gridColumn: "1 / span 2" }}>
                                <InputMask
                                  disabled={view}
                                  mask="99999-999"
                                  maskChar=""
                                  className="form-control"
                                  name="cep"
                                  value={form.cep || ""}
                                  onChange={(event) => {
                                    handleFormChange(event, indiceReal);
                                    setCepNotFoundMap((prev) => ({ ...prev, [indiceReal]: false }));
                                    const rawValue = event.target.value.replace(/\D/g, "");
                                    if (rawValue.length === 8) {
                                      buscarCepPaying(rawValue, indiceReal);
                                    }
                                  }}
                                  onBlur={(event) =>
                                    handleStopPointAddressBlur(indiceReal, event.target.name, event.target.value)
                                  }
                                >
                                  {(inputProps) => <input {...inputProps} id="cep" placeholder="00000-000" />}
                                </InputMask>
                                {form.cep && getCepError(form.cep, indiceReal) ? (
                                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                    {getCepError(form.cep, indiceReal)}
                                  </span>
                                ) : null}
                              </Field>

                              <Field label="Endereço *" span={4}>
                                <input
                                  disabled={view}
                                  type="text"
                                  name="logradouro"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  onBlur={(event) =>
                                    handleStopPointAddressBlur(indiceReal, event.target.name, event.target.value)
                                  }
                                  value={form.logradouro && form.logradouro}
                                  className="form-control"
                                  id="address"
                                />
                              </Field>

                              <Field label="Nº *" span={1}>
                                <input
                                  disabled={view}
                                  type="text"
                                  name="number"
                                  onChange={(event) => {
                                    event.target.value = event.target.value.replace(/\D/g, "");
                                    handleFormChange(event, indiceReal);
                                    consultStreetByStreet(indiceReal);
                                  }}
                                  value={form.number || ""}
                                  className="form-control"
                                  id="numberAddress"
                                />
                              </Field>

                              <Field label="Cidade *" span={2}>
                                <input
                                  disabled={view}
                                  type="text"
                                  name="city"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  onBlur={(event) =>
                                    handleStopPointAddressBlur(indiceReal, event.target.name, event.target.value)
                                  }
                                  value={form.city && form.city}
                                  className="form-control"
                                  id="cityAddress"
                                  placeholder=""
                                />
                              </Field>

                              <Field label="Estado *" span={1}>
                                <AntSelect
                                  disabled={view}
                                  style={{ width: "100%" }}
                                  placeholder="UF"
                                  options={STATE_UF}
                                  showSearch
                                  optionFilterProp="label"
                                  value={form.uf || undefined}
                                  onChange={(value) => {
                                    const fakeEvent = { target: { name: "uf", value: value } };
                                    handleFormChange(fakeEvent, indiceReal);
                                    handleStopPointAddressBlur(indiceReal, "uf", value);
                                  }}
                                />
                              </Field>

                              <div className="budget-form-field budget-form-span-2">
                                <label htmlFor="stateInitialLabel" className="font-test">
                                  Atualizar
                                </label>

                                {form.checkItemLocation ? (
                                  <Button
                                    disabled={view}
                                    variant="contained"
                                    size="small"
                                    onClick={() => consultStreetByStreet(indiceReal)}
                                    color="success"
                                    startIcon={<CheckCircleOutlineIcon />}
                                    sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                                  >
                                    Atualizado!
                                  </Button>
                                ) : (
                                  <Button
                                    disabled={view}
                                    variant="contained"
                                    size="small"
                                    onClick={() => consultStreetByStreet(indiceReal)}
                                    color="primary"
                                    startIcon={<LoopIcon />}
                                    sx={{ backgroundColor: "#012443", textTransform: "none", whiteSpace: "nowrap" }}
                                  >
                                    Atualizar
                                  </Button>
                                )}
                              </div>

                              {/* LINHA 4 */}
                              <Field label="Responsável" span={3}>
                                <input
                                  disabled={view}
                                  type="text"
                                  name="responsible_name"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  value={form.responsible_name && form.responsible_name}
                                  className="form-control"
                                  id="responsible"
                                />
                              </Field>

                              <Field label="Telefone Responsável" span={2}>
                                <InputMask
                                  disabled={view}
                                  mask="(99) 99999-9999"
                                  id="phoneResp"
                                  className="form-control"
                                  name="responsible_phone"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  value={form.responsible_phone && form.responsible_phone}
                                  placeholder="(00) 00000-0000"
                                />
                              </Field>

                              <Field label="Número da coleta *" span={2}>
                                <input
                                  disabled={view}
                                  readOnly
                                  type="text"
                                  name="number_collect"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  value={form.number_collect && form.number_collect}
                                  className="form-control"
                                  id="numbercoleta"
                                />
                              </Field>

                              <Field label="Data da Coleta" span={3}>
                                <input
                                  disabled={view}
                                  type="date"
                                  name="date_operation"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  value={form.date_operation || ""}
                                  className="form-control"
                                  id="datacoleta"
                                />
                              </Field>

                              <Field label="Hora da Coleta" span={2}>
                                <input
                                  type="time"
                                  disabled={view}
                                  id="time_operation"
                                  className="form-control"
                                  name="time_operation"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  value={form.time_operation || ""}
                                />
                              </Field>


                              {/* Latitude / Longitude */}
                              <Field label="Latitude" span={3} style={{ gridColumn: "1 / span 3" }}>
                                <input
                                  type="text"
                                  name="latitude"
                                  disabled={!form.manualCoordinatesEnabled}
                                  value={form.latitude || ""}
                                  className="form-control"
                                  id="latitude"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  readOnly={!form.manualCoordinatesEnabled}
                                />
                              </Field>
                              <Field label="Longitude" span={3}>
                                <input
                                  type="text"
                                  name="longitude"
                                  disabled={!form.manualCoordinatesEnabled}
                                  value={form.longitude || ""}
                                  className="form-control"
                                  id="longitude"
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                  readOnly={!form.manualCoordinatesEnabled}
                                />
                              </Field>

                              {/* Tipo + descricao quando carga */}
                              {form.operation.includes("carga") && (
                                <>
                                  <Field label="Tipo" span={2}>
                                    <select
                                      disabled={view}
                                      className="form-select"
                                      onChange={(e) => {
                                        const value = e.target.value || "";
                                        setFormFields((prev) => {
                                          const newFormFields = [...prev];
                                          newFormFields[indiceReal].type = value;
                                          return newFormFields;
                                        });
                                      }}
                                      value={form.type && form.type}
                                    >
                                      <option defaultValue="">Selecione</option>
                                      <option value="01">01 - Granel Sólido</option>
                                      <option value="02">02 - Granel líquido</option>
                                      <option value="03">03 - Frigorificada</option>
                                      <option value="04">04 - Conteinerizada</option>
                                      <option value="05">05 - Carga Geral</option>
                                      <option value="06">06 - Neogranel</option>
                                      <option value="07">07 - Perigosa (granel sólido)</option>
                                      <option value="08">08 - Perigosa (granel líquido)</option>
                                      <option value="09">09 - Perigosa (carga frigorificada)</option>
                                      <option value="10">10 - Perigosa (conteinerizada)</option>
                                      <option value="11">11 - Perigosa (carga geral)</option>
                                    </select>
                                  </Field>

                                  <Field label="Descrição" span={3}>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="descricao"
                                      className="form-control"
                                      value={form.descricao && form.descricao}
                                      onChange={(e) => {
                                        const value = e.target.value || "";
                                        setFormFields((prev) => {
                                          const newFormFields = [...prev];
                                          newFormFields[indiceReal].descricao = value;
                                          return newFormFields;
                                        });
                                      }}
                                      placeholder="Descrição do ponto"
                                    />
                                  </Field>
                                </>
                              )}


                              {/* Geoposição / Ver no mapa */}
                              <div className="budget-form-field budget-form-span-12" style={{ gridColumn: "1 / -1" }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <label htmlFor="Geoposição" className="font-test">
                                      Informar Geolocalização
                                    </label>
                                    <Checkbox
                                      disabled={view}
                                      id={`geoposicao-${index}`}
                                      checked={!!form.manualCoordinatesEnabled}
                                      onChange={(event, isChecked) => {
                                        setFormFields((prev) => {
                                          const newFormFields = [...prev];
                                          newFormFields[indiceReal] = {
                                            ...newFormFields[indiceReal],
                                            manualCoordinatesEnabled: isChecked,
                                          };
                                          return newFormFields;
                                        });
                                      }}
                                    />
                                  </Box>

                                  <a
                                    style={{ cursor: "pointer" }}
                                    href={`https://www.google.com/maps/search/?api=1&query=${form.latitude},${form.longitude}`}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                  >
                                    <label style={{ cursor: "pointer" }} className="font-test mb-0">
                                      Visualizar no Mapa
                                    </label>
                                  </a>
                                </Box>
                              </div>
                              {/* Observações + Canhoto */}
                              <Field label="Observações" span={12}>
                                <TextArea
                                  disabled={view}
                                  name="observation"
                                  value={form.observation && form.observation}
                                  onChange={(event) => handleFormChange(event, indiceReal)}
                                />
                              </Field>
                              <div className="budget-form-field budget-form-span-12">
                                {form.canhoto ? (
                                  <GalleryDialog data={form.canhoto} />
                                ) : (
                                  id ? (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                      <span className="font-test" style={{ color: "red" }}>
                                        Ainda não há comprovante de entrega
                                      </span>

                                      <Button
                                        disabled={view}
                                        variant="outlined"
                                        onClick={() => {
                                          setReferenc(null);
                                          handleClickOpen(form.id, form.operation[0]);
                                          setOrigem("Canhoto");
                                        }}
                                      >
                                        {nameButtonImport}
                                      </Button>
                                    </Box>
                                  ) : null
                                )}
                              </div>
                            </Box>
                          </Spin>
                        </CardContent>
                      </Card>
                    );
                  })}

                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      sx={primaryActionSx}
                      onClick={addFields}
                      disabled={view}
                      startIcon={<AddIcon />}
                    >
                      Adicionar Ponto de Parada
                    </Button>
                  </Box>
                </SectionCard>


                {/* Veículo */}
                <SectionCard
                  icon={<LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />}
                  title="Veículo"
                  subtitle="Categoria, carroceria e ocupação usadas neste orçamento."
                >
                  <Box className="budget-form-grid">
                    <div className="budget-form-field budget-form-span-12">
                      <strong>
                        <label htmlFor="occupation" className="form-label h5 mb-3">
                          <Chip
                            label={"Tipo de Veículo"}
                            sx={{
                              backgroundColor: "#012443",
                              color: "white",
                              fontWeight: "bold",
                              border: "2px solid #FF3100",
                              width: 150,
                              height: 30,
                              whiteSpace: "normal",
                              justifyContent: "center",

                              // Estilizando elementos internos (slots)
                              "& .MuiChip-label": {
                                fontSize: "0.9rem",
                                paddingLeft: "4px",
                                textAlign: "center",
                              },
                            }}
                          />{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </strong>

                      <div className="left-section">
                        {renderCategories()}
                      </div>
                    </div>

                    <div className="budget-form-field budget-form-span-12">
                      <strong>
                        <label htmlFor="bodywork-label" className="form-label h5 mb-3">
                          <Chip
                            label={"Tipo de Carroceria"}
                            sx={{
                              backgroundColor: "#012443",
                              color: "white",
                              fontWeight: "bold",
                              border: "2px solid #FF3100",
                              width: 170,
                              height: 30,
                              whiteSpace: "normal",
                              justifyContent: "center",

                              "& .MuiChip-label": {
                                fontSize: "0.9rem",
                                paddingLeft: "4px",
                                textAlign: "center",
                              },
                            }}
                          />{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </strong>

                      <div className="left-section">
                        {renderCategoriesBodyWork()}
                      </div>
                    </div>

                    <Field label="Ocupação *" span={6}>
                      <select
                        disabled={view}
                        className="form-select"
                        onChange={(e) => setOccupation(e.target.value)}
                        value={occupation || ""}
                      >
                        <option value="">Selecione</option>
                        <option value="Fracionado">Fracionado</option>
                        <option value="Dedicado">Dedicado</option>
                      </select>
                    </Field>

                    <div className="budget-form-field budget-form-span-6">
                      <div className="free-charge-wrapper">
                        <label htmlFor="freeOfCharge" className="free-charge-title">
                          Livre de Carga e Descarga{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="free-charge-group">
                          <input
                            disabled={view}
                            type="radio"
                            onChange={(e) => setFreeOfCharge(e.target.value)}
                            checked={freeOfCharge === "SIM"}
                            value="SIM"
                            className="free-charge-radio"
                            name="freeOfCharge"
                            id="btnFreeYes"
                            autoComplete="off"
                          />
                          <label htmlFor="btnFreeYes" className="free-charge-btn free-charge-yes">
                            SIM
                          </label>

                          <input
                            disabled={view}
                            type="radio"
                            onChange={(e) => setFreeOfCharge(e.target.value)}
                            checked={freeOfCharge === "NAO"}
                            value="NAO"
                            className="free-charge-radio"
                            name="freeOfCharge"
                            id="btnFreeNo"
                            autoComplete="off"
                          />
                          <label htmlFor="btnFreeNo" className="free-charge-btn free-charge-no">
                            {"não"}
                          </label>
                        </div>
                      </div>
                    </div>
                  </Box>
                </SectionCard>


                {/* Precificação */}
                <SectionCard
                  icon={<InventoryIcon sx={{ color: "#ffffff" }} />}
                  title="Precificação"
                  subtitle="Produtos e valores usados neste orçamento."
                >
                  <ProductTable
                    product={product}
                    onChange={handleProductsChange}
                    disabled={view}
                  />
                </SectionCard>


                {/* Resumo da Negociação */}
                <SectionCard
                  icon={<CheckCircleOutlineIcon sx={{ color: "#ffffff" }} />}
                  title="Resumo da Negociação"
                  subtitle="Vendedor, valores, pagamento e observações deste orçamento."
                >
                  <Box className="budget-form-grid">
                    <Field label="Vendedor *" span={3}>
                      <Autocomplete
                        disabled={view}
                        id="seller-select"
                        size="small"
                        options={sellersList}
                        getOptionLabel={(option) =>
                          typeof option === "string" ? option : formatName(option.name)
                        }
                        value={
                          sellersList.find(
                            (s) => sellerId && s.id === sellerId,
                          ) ||
                          sellersList.find((s) => s.name === seller) ||
                          seller
                        }
                        onChange={(event, newValue) => {
                          setSeller(newValue ? newValue.name : "");
                          setSellerId(newValue ? newValue.id || "" : "");
                        }}
                        onInputChange={(event, newInputValue) => {
                          setSeller(newInputValue);
                          if (!newInputValue) {
                            setSellerId("");
                          }
                        }}
                        noOptionsText="Nenhum vendedor encontrado"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label=""
                            placeholder="Selecione o vendedor"
                            id="seller"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          Boolean(option?.id && value?.id)
                            ? option.id === value.id
                            : option?.name === value?.name
                        }
                        forcePopupIcon
                        popupIcon={<KeyboardArrowDownIcon />}
                      />
                    </Field>

                    <Field label="Peso Transportado (Kg) *" span={3}>
                      <IntlCurrencyInput
                        disabled={view}
                        currency="BRL"
                        config={weightConfig}
                        placeholder="00.00"
                        onChange={handleChangeWeightCargo}
                        value={weightCargo && weightCargo}
                        className="form-control"
                        id="weightCargo"
                        maxLength={10}
                      />
                    </Field>

                    <Field label="Valor Transportado *" span={3}>
                      <IntlCurrencyInput
                        disabled={view}
                        currency="BRL"
                        config={currencyConfig}
                        placeholder="00.00"
                        onChange={handleChangeValueNF}
                        value={valueNF && valueNF}
                        className="form-control"
                        id="valueNF"
                        maxLength={15}
                      />
                    </Field>

                    <Field label="Valor do Frete *" span={3}>
                      <IntlCurrencyInput
                        disabled
                        currency="BRL"
                        config={currencyConfig}
                        placeholder="00.00"
                        onChange={handleChangeValueFreightage}
                        value={valueFreightage && valueFreightage}
                        className="form-control"
                        id="valueFreightage"
                        maxLength={15}
                      />
                    </Field>

                    <Field label="Condições de Pagamento *" span={3}>
                      {/* Select dinamico:
                            as opcoes sao carregadas do financeiro do embarcador (newEmbarcador),
                            não mais de uma lista fixa hardcoded. */}
                      <select
                        disabled={verifyPayment || view}
                        value={paymentCondition && paymentCondition}
                        id="paymentCondition"
                        className="form-select"
                        onChange={handleChangePaymentCondition}
                      >
                        <option value="">Selecione</option>
                        {/* Opcoes vem do financeiro do embarcador (newEmbarcador). */}
                        {(() => {
                          // Mantém o valor atual visível mesmo que não esteja mais na lista do embarcador.
                          const optionsToRender =
                            paymentCondition &&
                              !paymentConditionOptions.includes(paymentCondition)
                              ? [...paymentConditionOptions, paymentCondition]
                              : paymentConditionOptions;

                          return optionsToRender.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ));
                        })()}
                      </select>
                    </Field>

                    <Field label="Prazo de Entrega *" span={3}>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        className="form-control"
                        id="deliveryDeadline"
                        value={deliveryDeadline || ""}
                        onChange={(e) => setDeliveryDeadline(e.target.value)}
                        placeholder="Quantidade de dias"
                        disabled={view}
                      />
                    </Field>

                    <Field label="Observações" span={12}>
                      <TextArea
                        rows={4}
                        disabled={view}
                        value={observation || ""}
                        onChange={(e) => setObservation(e.target.value)}
                        placeholder={"Observações sobre o orçamento"}
                      />
                    </Field>
                  </Box>
                </SectionCard>


                {/* Botoes */}
                <Card sx={actionsCardSx}>
                  <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                    <Box className="budget-form-actions">
                      <Button
                        component={Link}
                        to="/budget/list"
                        variant="outlined"
                        startIcon={<ArrowBackOutlinedIcon />}
                        sx={secondaryActionSx}
                      >
                        Voltar
                      </Button>

                      {!view && (
                        <Button
                          variant="contained"
                          startIcon={<SaveOutlinedIcon />}
                          onClick={save}
                          disabled={carregando === 1}
                          sx={primaryActionSx}
                        >
                          Salvar
                        </Button>
                      )}

                      {!view && (
                        <Button
                          variant="contained"
                          startIcon={<SaveOutlinedIcon />}
                          onClick={saveAndEmitPdfV2}
                          disabled={carregando === 1}
                          sx={primaryActionSx}
                        >
                          Salvar e emitir PDF
                        </Button>
                      )}

                      {id && !isCopy && canShareBudgetPdf(status) && (
                        <Button
                          variant="outlined"
                          startIcon={<EmailIcon />}
                          onClick={sendBudgetPdfByEmail}
                          disabled={carregando === 1 || view}
                          sx={secondaryActionSx}
                        >
                          Enviar PDF por e-mail
                        </Button>
                      )}

                      {id && !isCopy && canShareBudgetPdf(status) && (
                        <Button
                          variant="outlined"
                          onClick={sendBudgetPdfByWhatsApp}
                          disabled={carregando === 1 || view}
                          sx={secondaryActionSx}
                        >
                          Enviar WhatsApp
                        </Button>
                      )}

                      {canApprove && id && !isCopy && status !== "Aprovado" && status !== "Cancelado" && (
                        <Button
                          variant="contained"
                          startIcon={<CheckCircleOutlineIcon />}
                          onClick={approveBudget}
                          disabled={carregando === 1}
                          sx={successActionSx}
                        >
                          Aprovar Orçamento
                        </Button>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </div>

              {/* Dialog de mensagem */}
              <ModernAlertDialog
                open={open}
                handleClose={() => setOpen(false)}
                title={title}
                msg={msg}
              />
              <GlobalSuccessModal
                open={showSuccessModal}
                handleClose={() => {
                  setShowSuccessModal(false);
                  navigate("/budget/list");
                }}
                title={successModalTitle}
              />
              <GlobalRequiredFieldsModal
                open={showRequiredFieldsModal}
                handleClose={() => setShowRequiredFieldsModal(false)}
                messages={requiredFieldsMessages}
              />
            </Box>

          }
        />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

const pageWrapperSx = {
  p: { xs: 2, md: 3 },
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const heroCardSx = {
  borderRadius: "18px",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-soft)",
};

const heroTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.25rem",
};

const heroSubtitleSx = {
  color: "rgba(1, 36, 67, 0.74)",
  fontSize: "0.92rem",
  lineHeight: 1.5,
  maxWidth: 760,
};

const statusPillSx = {
  border: "1px solid var(--new-client-primary-border)",
  borderRadius: "999px",
  color: "var(--new-client-primary)",
  background: "var(--new-client-primary-soft)",
  fontSize: "0.78rem",
  fontWeight: 700,
  px: 1.4,
  py: 0.6,
  whiteSpace: "nowrap",
};

const sectionCardSx = {
  borderRadius: "var(--new-client-radius-lg)",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-section)",
  background: "var(--new-client-surface-soft)",
};

const sectionTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.05rem",
};

const sectionSubtitleSx = {
  color: "rgba(1, 36, 67, 0.62)",
  fontSize: "0.79rem",
  lineHeight: 1.45,
};

const primaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  backgroundColor: "var(--new-client-primary)",
  minHeight: 40,
  px: 2,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "var(--new-client-primary-hover)",
  },
};

const secondaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  borderColor: "rgba(1, 36, 67, 0.28)",
  color: "var(--new-client-primary)",
  minHeight: 40,
  px: 2,
};

const actionsCardSx = {
  borderRadius: "var(--new-client-radius-lg)",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-section)",
};

const successActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  backgroundColor: "#28a745",
  minHeight: 40,
  px: 2,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#218838",
  },
};

function SectionCard({ icon, title, subtitle, children }) {
  return (
    <Card sx={sectionCardSx}>
      <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
        <Box className="budget-form-section-heading">
          <Box sx={cardIconSx}>{icon}</Box>
          <Box>
            <Typography sx={sectionTitleSx}>{title}</Typography>
            <Typography sx={sectionSubtitleSx}>{subtitle}</Typography>
          </Box>
        </Box>
        <Divider sx={{ mb: 2, borderColor: "rgba(1, 36, 67, 0.10)" }} />
        {children}
      </CardContent>
    </Card>
  );
}

function Field({ label, span = 3, children, style }) {
  return (
    <div className={`budget-form-field budget-form-span-${span}`} style={style}>
      <label>{label}</label>
      {children}
    </div>
  );
}

export default Budget;

































